module.exports={
  "nypd": {
    "defund-nypd": {
      "maintain": [
        {
          "slug": "andrew-yang",
          "quote": "“We have to do everything in our power to make sure that people feel safe walking around our neighborhoods, with our families. And so we have to take the resources that are being deployed on the police department and make sure they're actually making us safer. And also that officers are conducting themselves in a way that's responsible and professional and accountable.”",
          "source": "THE CITY interview",
          "date": "May 8, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "\"Crime is at an all-time high in terms of what we've seen recently. We've got to save our city.... You restore the money that was taken away, the billion dollars in the budget.\" ",
          "source": "Newsmax",
          "date": "Feb. 23, 2021",
          "url": "https://twitter.com/newsmax/status/1364316977385394176?s=20\n"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"I do not agree with 'defund the police'.... I do agree with community policing and rethinking and reforming the police department.\"",
          "source": "Central Brooklyn Political Action Association forum",
          "date": "Nov. 18, 2020",
          "url": "https://www.ny1.com/nyc/all-boroughs/news/2020/11/18/democratic-mayoral-contenders-stake-out-positions-on-nypd-reform"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The city is facing a budgetary crisis that's going to catch up with this very soon. Therefore, what I've called for are 10% cuts in each in the budget of each city agency, and that includes the NYPD.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"I am not for ‘defund.’ I'm for restructuring, having better policing, not fewer police.\"",
          "source": "Brian Lehrer Show, WNYC",
          "date": "Dec. 2, 2020",
          "url": "https://www.wnyc.org/story/meet-candidate-raymond-mcguire/"
        }
      ],
      "reduce-budget": [
        {
          "slug": "dianne-morales",
          "quote": "\"I've called for the creation of what we're calling community first responders, units, departments that would actually be staffed with trained personnel who are able to not just provide safe interventions but also access to resources for the community.\"",
          "source": "THE CITY interview",
          "date": "Oct. 1, 2020"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"We have to put the 'public' back in public safety. And that means a soup-to-nuts, top-to-bottom restructuring of what we call the New York City Police Department.\"",
          "source": "Central Brooklyn Political Action Association forum",
          "date": "Nov. 18, 2020",
          "url": "https://www.ny1.com/nyc/all-boroughs/news/2020/11/18/democratic-mayoral-contenders-stake-out-positions-on-nypd-reform"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Breaking down structural racism in New York City will require long-term, lasting change — and that must include reducing the NYPD’s budget.\"",
          "source": "NYC Comptroller's office",
          "date": "June 5, 2020",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-to-mayor-de-blasio-cut-1-1-billion-in-nypd-spending-over-four-years-and-reinvest-in-vulnerable-communities-and-vital-services/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"We need to dramatically reduce their role.... We need to reimagine the way we respond to violence well beyond policing.\"",
          "source": "Central Brooklyn Political Action Association forum",
          "date": "Nov. 18, 2020",
          "url": "https://www.gothamgazette.com/city/9920-democratic-mayoral-candidates-public-safety-forum"
        },
        {
          "slug": "art-chang",
          "quote": "\"I'm calling for a $1.3 billion immediate cut to the NYPD budget that would first be taken by reduction in uniformed officers.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"Defund the police; what exactly does that mean? In short, it means reallocating police department funding so that our communities are better set up for success. For me, it also means that it is time to re-imagine our policing concept.\"",
          "source": "Bklyner",
          "date": "July 16, 2021",
          "url": "https://bklyner.com/reimagining-public-safety-in-nyc-opinion/"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"I’m really out here leading the way on Abolishing the Police... thank me later !\"",
          "source": "Twitter",
          "date": "Feb. 8, 2021",
          "url": "https://twitter.com/PaperboyPrince/status/1358790312806789121"
        }
      ],
      "keep-budget": [
        {
          "slug": "fernando-mateo",
          "quote": "\"I would add thousands more cops to the police force. I believe that we should have minimally two cops in each subway station, 24 hours, seven days a week.\"",
          "source": "Decision NYC With Ben Max, MNN",
          "date": "March 2, 2021",
          "url": "https://www.youtube.com/watch?v=tuhoJZUef9A"
        }
      ]
    },
    "nypd-residency": {
      "yes-new": [
        {
          "slug": "andrew-yang",
          "quote": "\"You should be of the community, certainly when you start on the force. And that, I believe, would fundamentally change the dynamic, because instead of seeing folks as strangers or potential perpetrators, you see them as your neighbors.\"",
          "source": "WNYC",
          "date": "Jan. 26, 2021",
          "url": "https://www.wnyc.org/story/meet-candidate-andrew-yang"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“I will make sure that new cops live in the city. It can't be an 'us versus them' geography.”",
          "source": "Campaign video",
          "date": "Dec. 10, 2020",
          "url": "https://www.youtube.com/watch?v=DEQb3cqw2CA"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "source": "Gothamist ",
          "date": "Feb. 2, 2021",
          "url": "https://gothamist.com/news/five-mayoral-contenders-say-they-want-nypd-officers-live-nyc-would-change-anything"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“When I grew up, I knew the cops in my neighborhood, and I didn't see them as someone that was there to police me. … I would require that new officers that are coming on to the force should live in the city. You have to be in touch with what's going on in the city.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "no-requirement": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "\"They can't afford to live in New York City, so it doesn't matter where they live. It matters where they came from. It matters what ethnic background they have. It matters where you place them that they can be the most productive.\"",
          "source": "Decision NYC With Ben Max, MNN",
          "date": "March 2, 2021",
          "url": "https://www.youtube.com/watch?v=tuhoJZUef9A&t=622s"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"With the salaries they're paid, you can't simply change the rule overnight, and all of a sudden require NYPD officers to up in their lives and move into the city.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "yes-all": [
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"We...need a residency requirement so that our police officers reflect the communities they live in.\"",
          "source": "Twitter",
          "date": "Jan. 31, 2021",
          "url": "https://twitter.com/search?q=%22residency%22%20AND%20officers%20(ShaunDonovanNYC)&src=typed_query&f=live"
        },
        {
          "slug": "art-chang",
          "quote": "Along with imposing residency requiment, Chang would give officers \"early retirement incentives.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ]
    },
    "mentally-ill-response": {
      "yes-sometimes": [
        {
          "slug": "andrew-yang",
          "quote": "\"Another data-driven approach is to scale up other organizations to respond to emergency calls instead of the police.\"",
          "source": "Medium",
          "date": "June 8, 2020",
          "url": "https://medium.com/@andrew_yang/addressing-police-brutality-3945c09e46d1"
        },
        {
          "slug": "eric-adams",
          "quote": "\"I will never put a city employee, psychiatrist, family members or anyone else in a situation that could endanger the lives of innocent people or the person who's going through a mental health crisis.... So no, I will not just openly state, ‘Under no circumstances should a police officer respond.’\"",
          "source": "Citizen Action mental health town hall",
          "date": "Dec. 15, 2020",
          "url": "https://www.facebook.com/watch/live/?v=669841223693678&ref=watch_permalink"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“We have to completely transform the way we respond with an alternative 911 that ensures that we're sending out trained professionals.”",
          "source": "Community Voices Heard forum",
          "date": "Feb. 26, 2021",
          "url": "https://www.youtube.com/watch?v=kqwkumnm-3g"
        },
        {
          "slug": "ray-mcguire",
          "quote": "“When someone calls 911 for those cases, the responding personnel should be equipped to deal with the situation effectively and nonviolently. The NYPD’s emergency response teams, therefore, have to include social-service workers”",
          "source": "",
          "date": "May 31, 2021",
          "url": "https://www.wsj.com/articles/nypd-cant-fight-crime-on-its-own-11622494040?mod=article_inline"
        }
      ],
      "no-never": [
        {
          "slug": "dianne-morales",
          "quote": "\"Provide the appropriate interventions and services and supports at the time, in the moment, not sending an armed individual to respond to a mental health crisis.\"",
          "source": "Citizen Action mental health town hall",
          "date": "Dec. 17, 2020",
          "url": "https://www.facebook.com/watch/live/?v=669841223693678&ref=watch_permalink"
        },
        {
          "slug": "maya-wiley",
          "quote": "“The NYPD is not the appropriate response to people who need mental-health-trained and peer mental health support.”",
          "source": "Citizen Action mental health town hall",
          "date": "Dec. 15, 2020",
          "url": "https://www.youtube.com/watch?v=XWzCsQuHZn0"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I support unequivocally moving those responsibilities away from armed officers to mental health professionals and counselors.\"",
          "source": "Citizen Action mental health town hall",
          "date": "Dec. 15, 2020",
          "url": "https://www.youtube.com/watch?v=XWzCsQuHZn0"
        },
        {
          "slug": "art-chang",
          "quote": "Chang calls for a response team modeled after a program in Eugene, Oregon: \"unarmed, specifically trained to address these kinds of issues.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"We should have a Love team that focuses on mental health and well-being.\"",
          "source": "THE CITY Interview",
          "date": "May 3, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"The role of the police is supposed to be proactive about preventing crime. If you have a mental issue or you're going through something, you haven't committed a crime.\"",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "depends": [
        {
          "slug": "curtis-sliwa",
          "quote": "\"I agree with some of the critics of the police department: Cops don't want to be social workers, don't want to have to deal with mental health care problems. You should have special units in each precinct compose the mental health experts who can respond simultaneously with the police when there is an emotionally disturbed person having an episode.\"",
          "source": "Decision NYC With Ben Max, MNN",
          "date": "Jan. 27, 2021",
          "url": "https://www.youtube.com/watch?v=VnoiKNZrlDs&t=365s"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We should have nurses or someone else who have degrees in psychology participate with police, but they need to do it hand in hand in partnership.”",
          "source": "The Brian Lehrer Show, WNYC",
          "date": "Nov. 25, 2020",
          "url": "https://www.wnyc.org/story/meet-candidate-kathryn-garcia/"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We need to train more police on how to deescalate conflicts, how to help people, but also reserve the ability  to respond for everyone's safety when absolutely necessary.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    },
    "nypd-disciplining-officers": {
      "maintain-authority": [
        {
          "slug": "andrew-yang",
          "quote": "\"I will be amending disciplinary power from the NYPD commissioner so that an independent oversight body is able to hold officers accountable for misconduct\"",
          "source": "Streetsblog",
          "date": "Feb. 5, 2021",
          "url": "https://nyc.streetsblog.org/2021/02/05/decision-2021-andrew-yang-answers-streetsblogs-candidate-questionnaire/"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"My police commissioner would be strictly accountable to me on discipline decisions, and I would hire someone I trust to have final authority on that decision.\"",
          "source": "POLITICO",
          "date": "Feb. 16, 2021",
          "url": "https://www.politico.com/states/new-york/albany/story/2021/02/16/mayoral-candidates-split-on-disciplinary-authority-for-police-1363681"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"As mayor, I will hold the police commissioner accountable for taking appropriate disciplinary actions, and further empower the CCRB to investigate misconduct — including access to body camera footage within 48 hours of request.\"",
          "source": "Campaign Facebook page ",
          "date": "Feb. 21, 2021",
          "url": "https://www.facebook.com/Ray4Mayor/photos/a.121251559746470/220848936453398/?type=3"
        }
      ],
      "civilian-ccrb": [
        {
          "slug": "dianne-morales",
          "quote": "\"Advance a democratically-elected Civilian Complaint Review Board (CCRB) and empower it to discipline officers.\"",
          "source": "Campaign website ",
          "date": "",
          "url": "https://www.dianne.nyc/defund"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"The city should end the police commissioner’s authority to treat CCRB investigations and recommendations as advisory — and instead grant the CCRB power to make final disciplinary decisions.\"",
          "source": "New York Daily News Op-Ed",
          "date": "Nov. 20, 2020",
          "url": "https://www.nydailynews.com/opinion/ny-oped-how-to-police-the-police-20201120-zpxu7jhsbvcdlbtrh5t76ovy3y-story.html"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"Hold individual officers responsible for bad acts that too often go unpunished today, including by following the determinations of the Civilian Complaint Review Board and by enforcing a clear, publicly available set of disciplinary standards\"",
          "source": "The Root",
          "date": "Feb. 10, 2021",
          "url": "https://www.theroot.com/nyc-mayoral-candidate-shaun-donovan-unveils-criminal-ju-1846234346"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"That commissioner having 100% authority must change.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"I'm calling for the City Council ratification of the mayoral nomination of a police commissioner, removal of the police chief's sole power over disciplinary matters.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"You can't have the person you're working with checking the person that’s doing wrong. It just won't work. You need an outside person, an impartial party, looking at it impartially and saying, ‘This is right or wrong’ based upon the parameters that we set as to what's appropriate.\"",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "mayor": [
        {
          "slug": "eric-adams",
          "quote": "\"The police commissioner should not have the final say on discipline — the mayor should — and the timeline for determining punishment should be shortened significantly.\"",
          "source": "POLITICO",
          "date": "Feb. 16, 2021",
          "url": "https://www.politico.com/states/new-york/albany/story/2021/02/16/mayoral-candidates-split-on-disciplinary-authority-for-police-1363681"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"The Police Commissioner will not have final disciplinary authority.\"",
          "source": "POLITICO",
          "date": "Feb. 16, 2021",
          "url": "https://www.politico.com/states/new-york/albany/story/2021/02/16/mayoral-candidates-split-on-disciplinary-authority-for-police-1363681"
        }
      ]
    }
  },
  "corona-recovery": {
    "mandatory-vac": {
      "some-yes": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "no-mandate": [
        {
          "slug": "eric-adams",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"If you were to impose government mandates for people to take the vaccines, then that would fuel even more resistance.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“Some individuals have maybe a medical reason or a religious reason why they don't want to take the vaccine. So I just want to be mindful of that.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "yes-mandatory": [
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        }
      ]
    },
    "relief": {
      "ongoing": [
        {
          "slug": "andrew-yang",
          "quote": "Yang proposes a basic income, an average of $2,000 a year to 500,000 poor people: \"All New Yorkers are eligible for our cash relief program regardless of immigration status.… Our goal is to end extreme poverty in New York City.\"",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.yangforny.com/policies/a-sanctuary-city"
        },
        {
          "slug": "dianne-morales",
          "quote": "“I would begin to address the current crisis by providing folks with some basic economic relief for every household, especially the excluded workers and those that we know were left out on the federal and state level.”",
          "source": "Community Voices Heard forum",
          "date": "Feb. 26, 2021",
          "url": "https://www.youtube.com/watch?v=kqwkumnm-3g"
        },
        {
          "slug": "eric-adams",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley tweeted that it is “unacceptable” that lower-income\nteens, the elderly and undocumented immigrants who are taxpayers did not receive federal stimulus checks.",
          "source": "Twitter ",
          "date": "April 6, 2020",
          "url": "https://twitter.com/mayawiley/status/1247220495235395586"
        },
        {
          "slug": "scott-stringer",
          "quote": "As city comptroller, Stringer proposed to establish an emergency relief fund with private partners to help undocumented immigrants excluded from federal aid.",
          "source": "NYC Comptroller's office",
          "date": "March 1, 2020",
          "url": "https://comptroller.nyc.gov/wp-content/uploads/documents/Frontline_Workers_032020.pdf?utm_source=Media-All&utm_campaign=5c18919e2d-EMAIL_CAMPAIGN_2017_05_31_COPY_01&utm_medium=email&utm_term=0_7cd514b03e-5c18919e2d-154094265"
        },
        {
          "slug": "shaun-donovan",
          "quote": "At a Heroes Act hearing in Congress last year, Donovan said federal policies should give immigrants access to the help they need to keep their families afloat.",
          "source": "Heroes Act hearing, House Financial Services Committee",
          "date": "July 23, 2020",
          "url": "https://www.congress.gov/116/meeting/house/110925/witnesses/HHRG-116-BA00-Wstate-DonovanS-20200723.pdf"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“A lot of undocumented immigrants that are here, that are working here — most come here because they want to make their lives better. … We have to treat them like human beings, and we have to support them.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "no-relief": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        }
      ],
      "one-time": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We need to provide one-time assistance to undocumented immigrants who are in need, just like we're providing additional assistance to other Americans who have been out of work.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ]
    },
    "reopening": {
      "slow": [
        {
          "slug": "andrew-yang",
          "quote": "“I will confess to being a parent that has been frustrated by how slow our schools have been to open, and I do believe that the UFT has been a significant reason why our schools have been slow to open.\"",
          "source": "POLITICO",
          "date": "March 18, 2021",
          "url": "https://www.politico.com/states/new-york/albany/story/2021/03/18/yang-lays-blame-on-teachers-union-for-sluggish-pace-of-school-reopenings-1368977"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley tweeted: \"The CDC say it's safe for students to return to the classroom full time with proper protocols in place. I'm calling on the Mayor and Chancellor to open schools and let every one of our kids learn, with their teachers, safely and in person 5 days a week.\"",
          "source": "Twitter ",
          "date": "March 19, 2021",
          "url": "https://twitter.com/mayawiley/status/1372975841530032132"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Studies show that it's very unlikely for kids to spread COVID-19. And in addition, the pandemic is, appears to be, under control within the city. We need to have our kids back in school five days a week.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"It's been tremendously frustrating to watch this mayor fail to recognize that he has so much knowledge and talent within his own department.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "“Kids are safer inside a school building than outside of it.... There are so many things about in-person learning that you simply can’t replicate in remote sessions.”",
          "source": "The New York Times",
          "date": "Dec. 9, 2020",
          "url": "https://www.nytimes.com/2020/12/09/nyregion/scott-stringer-schools-reopening.html"
        }
      ],
      "quick": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        }
      ],
      "appropriate": [
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“There are some schools that are actually ready. There's some schools that aren't good. Given this being an unprecedented time, should we proceed with those schools who are ready and let them go ahead? And just let those schools who aren't ready, take the additional time that they need. We can't be one size fits all in this time because this is an unprecedented time.”",
          "source": "THE CITY interview",
          "date": "Sept. 24, 2020"
        }
      ]
    },
    "open-street": {
      "expand": [
        {
          "slug": "andrew-yang",
          "quote": "\"I would make the Open Streets and Restaurants programs permanent. We saw how integral these programs were during the pandemic.\"",
          "source": "Streetsblog",
          "date": "Feb. 5, 2021",
          "url": "https://nyc.streetsblog.org/2021/02/05/decision-2021-andrew-yang-answers-streetsblogs-candidate-questionnaire/"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales said she is “fully committed to open streets, safe streets, more bicycle-friendly streets” but adds any program should be done with an “eye toward not disproportionately impacting” people who rely on cars for transportation.",
          "source": "Brooklyn Democratic Mayoral Forum",
          "date": "Jan. 19, 2021",
          "url": "https://www.youtube.com/watch?v=az9nYuezxiI"
        },
        {
          "slug": "eric-adams",
          "quote": "\"It’s a shame that it took a pandemic to embrace public space ideas that have become commonplace around the world. We must expand this program to underserved communities and communities that have a dearth of public space options.\"",
          "source": "Streetsblog",
          "date": "Dec. 14, 2021",
          "url": "https://nyc.streetsblog.org/2020/12/14/decision-2021-mayoral-hopefuls-plan-for-our-covid-socked-streets/"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"Ensure our public spaces serve the public first. That means making Open Streets permanent, creating new Complete Streets in all five boroughs.\"",
          "source": "Twitter ",
          "date": "Feb. 2, 2021",
          "url": "https://twitter.com/KGforNYC/status/1356713198515351552"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"Through my campaign’s 'People’s Assemblies' process, I will ensure that my proposal to improve this program will be based on participation and feedback by the communities who will be impacted by this program.\"",
          "source": "Streetsblog",
          "date": "Dec. 14, 2020",
          "url": "https://nyc.streetsblog.org/2020/12/14/decision-2021-mayoral-hopefuls-plan-for-our-covid-socked-streets/"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"In my administration, curb and street space throughout the five boroughs will be repurposed for wider sidewalks, street seating, bus shelters, bike parking, Citi Bike docking stations, public restrooms, improved garbage collection, playstreets and playgrounds, bus lanes, bike lanes, plazas, and much more.\"",
          "source": "Streetsblog",
          "date": "Dec. 14, 2020",
          "url": "https://nyc.streetsblog.org/2020/12/14/decision-2021-mayoral-hopefuls-plan-for-our-covid-socked-streets/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "He said he would make the Open Streets program permanent and take a “holistic and justice-driven approach\" instead of the current police oversight of the vast majority of Open Streets.",
          "source": "Streetsblog",
          "date": "Dec. 14, 2021",
          "url": "https://nyc.streetsblog.org/2020/12/14/decision-2021-mayoral-hopefuls-plan-for-our-covid-socked-streets/"
        },
        {
          "slug": "art-chang",
          "quote": "\"I don't think that the current design of the street dining makes long-term sense. But I do but I do believe that we need to redesign the streets.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "“I will reimagine our streets in ways that create more public space, improve safety for pedestrians and cyclists, create space for restaurants and other small businesses, reduce congestion and increase sustainability. Doing this will require reductions in street parking in some neighborhoods, so we have to make sure that New Yorkers who need a vehicle — particularly our mobility impaired and working families — are rightly accommodated.",
          "source": "Central Brooklyn Independent Democrats forum",
          "date": "Jan. 19, 2021",
          "url": "https://www.youtube.com/watch?v=az9nYuezxiI"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“The open streets with the restaurants — I think it created a huge opportunity for restaurants.… It actually gives them additional square footage now to be able to accommodate more people, which from my standpoint means that they'll be able to get their businesses back to where they were more quickly.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "no-open-street": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"These outdoor dining facilities, they don't comply with building codes. It's a disaster waiting to happen.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    }
  },
  "education": {
    "shsat": {
      "mixed-measures": [
        {
          "slug": "andrew-yang",
          "quote": "“I would not abandon the SHSAT, but I would broaden the criteria were using and I think if we do that we can actually get some of the families into these specialized high schools in a way that's going to benefit them.”",
          "source": "Spectrum News NY1",
          "date": "Jan. 14, 2021",
          "url": "https://twitter.com/NY1/status/1349890545099960324"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "\"The specialty test must be maintained for the elite high schools and the Gifted and Talented programs have to be maintained but we also have to put pressure on promoting vocational training.\"",
          "source": "NY1",
          "date": "Feb. 27, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/02/27/nyc-elections-2021-whos-running-curtis-sliwa-on-the-issues-public-safety-crime-bill-de-blasio-donald-trump-rudy-giuliani#"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"I believe that we can take that on modify the test and, if necessary if we don't get results, get rid of it, but we should also recognize that there are just eight specialized high schools in the city...there are roughly 400 high schools.\"",
          "source": "Columbia Law School education panel",
          "date": "Jan. 27, 2021",
          "url": "https://www.youtube.com/watch?v=umpomW2p4IU&feature=youtu.be"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer called for a holistic admission process. \"Schools can have an admissions committee that considers other aspects\" such as \"diversity, essays, accomplishment, the student's upbringing.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "“I think the specialized high schools are one element on which we should focus. I would teach, though, to the child; I would not teach to the test. I think we need to expand criteria.\"",
          "source": "New York Jewish Agenda forum",
          "date": "Feb. 18, 2021",
          "url": "https://www.youtube.com/watch?v=k69AxJeLU58&feature=emb_title"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“When you go to the college level, you have to take entrance exams. And those exams are going to be even more significant as it relates to your ability to get into a school. … What we need to do is invest in kids equally, so everybody's bright, so that everyone has opportunity.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "abolish": [
        {
          "slug": "dianne-morales",
          "quote": "“As a graduate of a specialized high school, I will say — much to the chagrin of many of my classmates — that I do not believe that the SHSAT serves our children.”",
          "source": "New York Jewish Agenda forum",
          "date": "Jan. 15, 2021",
          "url": "https://www.youtube.com/watch?v=k69AxJeLU58&feature=emb_title"
        },
        {
          "slug": "maya-wiley",
          "quote": "“We have to eliminate school-based admissions policies that are not based on anything except privileging folks who can pay for tutoring and supports to get people through a test.”",
          "source": "Uptown Community Democrats forum",
          "date": "Jan. 15, 2021",
          "url": "https://www.youtube.com/watch?v=1EraRzBSZSM&feature=youtu.be"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Replace it with a seventh grade statewide test that will allow more black and brown students to access our specialized high schools.\"",
          "source": "New York Jewish Agenda forum",
          "date": "Feb. 18, 2021",
          "url": "https://www.youtube.com/watch?v=k69AxJeLU58&feature=emb_title"
        },
        {
          "slug": "art-chang",
          "quote": "Chang favors phasing out the SHSAT over four years, saying: \"65% of black students do not graduate with proficiency. And what's little known is that 60% of Asian students do not also graduate with proficiency. SHSAT pits communities of colors against each other in a false debate.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "keep": [
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia has suggested implementing the “Texas model,” where top-performing students at every middle school are offered seats at specialized high schools.",
          "source": "Uptown Community Democrats forum",
          "date": "Jan. 15, 2021",
          "url": "https://www.youtube.com/watch?v=GDHsh2cdHQo"
        }
      ]
    },
    "charter": {
      "more": [
        {
          "slug": "andrew-yang",
          "quote": "\"To the extent that there are charters that are allocated by the state that are not being used, I think that we should look at reallocating them. But in my mind it’s about whether a school is performing for our kids. There're public schools doing great work and there're charter schools doing great work and that should be the goal.\"",
          "source": "THE CITY interview",
          "date": "March 11, 2021"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“I do support raising the charter cap because I want every kid to have the opportunity and I want every adult who's thinking creatively about how to do education, do education well, to have the opportunity to do that. I mean I wish that we had great public schools in every neighborhood today but I'm not willing to wait until we get there for the kids who are in school right now.”",
          "source": "2021 Mayoral Forum on Educational Equity in NYC",
          "date": "May 24, 2021",
          "url": "https://youtu.be/L0GwUmT4XqM?t=1018"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Charter schools are actually in underserved communities. And they're doing good work. They're trying new pedagogical methods for troubled children.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "McGuire supports city control of the cap on charter schools. “As mayor, Ray will work to increase the number of charter chools allowed in NYC and give families as many high-quality school options as possible,” said a spokesperson.",
          "source": "THE CITY Interview ",
          "date": "March 11, 2021"
        }
      ],
      "stricter": [
        {
          "slug": "curtis-sliwa",
          "quote": "“I'm a supporter of charter schools but I really wish that they would devote some of their curriculum to vocational training.” ",
          "source": "Decision NYC With Ben Max, MNN",
          "date": "Jan. 27, 2021",
          "url": "https://www.gothamgazette.com/city/10117-decision-nyc-curtis-sliwa-runs-nyc-mayor-2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": " \"As Mayor, I will consider advocating to lift the cap to increase the number of high-quality charter schools under stricter conditions than what is currently in place. Charter schools are a small but critical part of the educational landscape in New York City that has piloted innovations and are disproportionately chosen by Black and Latinx families; where they are performing well, they must be allowed to continue to serve the families who have picked them as the best option for their children.\"",
          "source": "THE CITY interview",
          "date": "Feb. 8, 2021"
        }
      ],
      "no-discourage": [
        {
          "slug": "dianne-morales",
          "quote": "Morales said the city should gain control over the number of charter schools and stop them from increasing.",
          "source": "Empire State Indivisible's Albany Agenda forum",
          "date": "Feb. 8, 2021",
          "url": "https://www.facebook.com/EmpireStateIndivisible/videos/3844337965604204"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer supports keeping the current cap on charter schools and letting the state control it.",
          "source": "THE CITY interview",
          "date": "March 11, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"Increasing the number of charter schools will take away from the focus on improving quality in the city's public schools.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        }
      ]
    },
    "admissions-district": {
      "set-asides": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“We should make sure that we keep the doors open for people to have access to the best of the best. When my son was in middle school, he didn't go to the school in his district. He went to another school because this school offered more.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "no-admissions": [
        {
          "slug": "dianne-morales",
          "quote": "“We should remove all screenings and all barriers to access to schools that exist currently. I think that also means that we need to look at redrawing district lines and district boundaries.”",
          "source": "Columbia Law School education panel",
          "date": "Jan. 27, 2021",
          "url": "https://youtu.be/umpomW2p4IU?t=1807"
        },
        {
          "slug": "eric-adams",
          "quote": "“I think we need to re-examine any method or barrier that is preventing us from diversifying our schools.”",
          "source": "Columbia Law School education panel",
          "date": "Jan. 27, 2021",
          "url": "https://youtu.be/umpomW2p4IU?t=5486"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "Chang said removing geographical restrictions \"allows for the opportunity for greater integration.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "yes-limit": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Sending kids to schools in the neighborhoods in which they live is important. That creates a sense of community.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    },
    "raise-money": {
      "redistribute": [
        {
          "slug": "andrew-yang",
          "quote": "Yang said sharing should be “voluntary.”",
          "source": "UFT Mayoral Town Hall",
          "date": "April 7, 2020",
          "url": "https://vimeo.com/534377415/16063fe141"
        },
        {
          "slug": "eric-adams",
          "quote": "\"Let’s share the knowledge to share the dollars so that we can have all our children succeed together.”",
          "source": "UFT Mayoral Town Hall",
          "date": "April 7, 2020",
          "url": "https://vimeo.com/534377415/16063fe141"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"I would share to a point, having been on the PTA and on the [school] leadership team.\"",
          "source": "Education First Mayoral Candidates Forum",
          "date": "Jan. 28, 2021",
          "url": "https://youtu.be/ERgkpG2Oo_Y?t=3604"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"All kids count.\"",
          "source": "UFT Mayoral Town Hall",
          "date": "April 7, 2020",
          "url": "https://vimeo.com/534377415/16063fe141"
        },
        {
          "slug": "scott-stringer",
          "quote": "“Under my education plan, we're going to equalize after-school funding. If one school gets chess, every school gets chess. One school gets robotics, every school gets robotics. If one school gets athletics, everyone gets athletics. We're going to create one system, so once the PTA is known that everyone is equal in every school. We can share that prosperity.”",
          "source": "UFT Mayoral Town Hall",
          "date": "April 7, 2020",
          "url": "https://vimeo.com/534377415/16063fe141"
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Ability of of these associations to raise money furthers inequality in our school systems, which affects us all at the end of the day.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"We need to set a threshold per student of money that can be raised. And...50 cents of every dollar raised should go into a pool to benefit all the other schools.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "Taylor said parents in low-income neighborhoods don't have extra money and networks to contribute to school parent associations. “If we don't create an equitable system, it won't ever exist.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "yes": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"Would I share the funding of those people who have been successful funding with others? I would share the resources.\"",
          "source": "Education First Mayoral Candidates Forum",
          "date": "Jan. 28, 2021",
          "url": "https://youtu.be/ERgkpG2Oo_Y?t=3592"
        }
      ],
      "no-limits": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "transportation": {
    "bike": {
      "expand-far": [
        {
          "slug": "andrew-yang",
          "quote": "\"I want it so that, when someone moves to New York City, they think, ‘Great! I don't need to own a car.’ One aspect of that is going to be making the city as bike-friendly as it possibly can be.\"",
          "source": "Newsweek",
          "date": "Feb. 23, 2021",
          "url": "https://www.newsweek.com/andrew-yang-believes-bikes-wants-make-cars-unnecessary-new-yorkers-1571154"
        },
        {
          "slug": "dianne-morales",
          "quote": "\"We need to expand bike lanes, busways and pedestrian plazas across this city. And that’s just the start. We need to redesign our streets and ensure our more dangerous drivers cannot continue getting behind the wheel.\"",
          "source": "Twitter",
          "date": "Nov. 15, 2020",
          "url": "https://twitter.com/search?q=bike%20(from%3A%40Dianne4NYC)&src=typed_query"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"We need to ensure that people think of bike lanes in the same way they think of their subway, as a network.\"",
          "source": "Bike New York forum",
          "date": "March 5, 2021",
          "url": "https://youtu.be/L9KV13cWSIU?t=826"
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer's campaign website calls for a 425-mile, five-borough bikeway connected to greenways.",
          "source": "Campaign website",
          "date": "",
          "url": "https://stringerformayor.com/plans/transportation"
        },
        {
          "slug": "art-chang",
          "quote": "\"Local community community boards should have input, but they should not have veto rights over bike lanes.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        }
      ],
      "expand-moderate": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "\"People connect bike lanes with gentrification.... Bike lanes have received a bad rap because people believe it’s an indicator that they’re going to be displaced, and it’s not something that’s part of the overall build-out of their community.\"",
          "source": "Bike New York forum",
          "date": "March 5, 2021",
          "url": "https://youtu.be/RKKnUuASWpg?t=801"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley's campaign website calls for the creation of 300 miles of bike lanes.",
          "source": "Campaign website",
          "date": "",
          "url": "https://mayawileyformayor.com/maya-wileys-community-first-climate-action-plan/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“You start to change that conversation not just with what you’re taking away in terms of cars, but what you’re adding in terms of options.”",
          "source": "Bike New York forum",
          "date": "",
          "url": "https://youtu.be/braCw89o74M?t=761"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"One of my key proposals is to build a bicycle superhighway along Third Avenue in Manhattan, which would extend to the to Third Avenue in The Bronx.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "“What we haven’t done with major projects like this before is involve the people who are going to be most impacted.... We prescribe, but we haven’t included. In my leadership, we would get the right leaders in the communities and if we have to go down by neighborhood, then we’ll do that, because that’s where people’s lives will be most impacted.”",
          "source": "Streetsblog",
          "date": "March 3, 2021",
          "url": "https://nyc.streetsblog.org/2021/03/03/analysis-mayoral-candidates-have-big-plans-for-the-streets-but-not-all-know-how-to-get-it-done/"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“Although we would like more people to ride bikes, it's not happening in every community in the same way.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "alter-remove": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        }
      ]
    },
    "ferry": {
      "raise": [
        {
          "slug": "andrew-yang",
          "quote": "\"We're subsidizing them as our budget is constrained. We'll have to make tough choices. I would try to support the routes that have proven they're helping New Yorkers and have demand.\"",
          "source": "Forum on the Future of Transportation",
          "date": "March 25, 2021",
          "url": "https://www.facebook.com/watch/live/?v=1093187057816620&ref=watch_permalink"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia's campaign calls for redistributing funds from the ferry subsidy to half-price Fair Fares expansion and MTA bus operations.",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.kgfornyc.com/policy/transportation-2/"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"What we really need to do is expand it ... where we need it to make sure we have that service because of usage, but also increase the rates like we do for express bus service.\"",
          "source": "Forum on the Future of Transportation",
          "date": "March 25, 2021",
          "url": "https://www.facebook.com/watch/live/?v=1093187057816620&ref=watch_permalink"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"I do see ferries as having a critical role.... I don't mind that we subsidize them given that we subsidize cars more than anything else.... I think the question has to be, are they equitably distributed and where is their demand?\"",
          "source": "Forum on the Future of Transportation",
          "date": "March 25, 2021",
          "url": "https://www.facebook.com/watch/live/?v=1093187057816620&ref=watch_permalink"
        }
      ],
      "continue": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "raise-evaluate": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "“I would rework the contract.… But ultimately, the goal has to be, if we're going to do I think transportation subsidy and expansion, I would drive it into the buses and the bus lane, because I think that's a better bang for the buck. But I would keep the service of the communities right now.”",
          "source": "Forum on the Future of Transportation",
          "date": "March 25, 2021",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-calls-on-dot-to-immediately-explore-taking-over-nyc-ferry/"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The New York City ferry system is a money pit. That must change because we can't continue the dramatic subsidies the ferry system is getting right now.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "Chang says the ferry system is integral to some parts of the city but that expansion has to done on a cost-effective basis.",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“We should make the ridership and the schedule has to make sense so that the city is not operating the ferries at a deficit.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "alter": [
        {
          "slug": "dianne-morales",
          "quote": "\"Some of these routes just aren't really getting a ton of customers, and we're subsidizing them at a time when our budget is going to be constrained.… My goal would be to try and support the routes that, frankly, have proven that they're helping New Yorkers and have demand.\"",
          "source": "Forum on the Future of Transportation",
          "date": "March 25, 2021",
          "url": "https://www.facebook.com/watch/live/?v=1093187057816620&ref=watch_permalink"
        }
      ]
    },
    "transit-system": {
      "yes-share": [
        {
          "slug": "andrew-yang",
          "quote": "\"I've looked at the numbers. It's not pretty, but the reality is, it's very very hard to manage a recovery if you're not managing the way five and a half million New Yorkers get around every single day and that includes the subways.\"",
          "source": "District Council 37 Forum",
          "date": "Jan. 26, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=2101"
        }
      ],
      "yes-full": [
        {
          "slug": "dianne-morales",
          "quote": "\"I think over the long term, it would be great for the city to get control of the MTA, but that can't happen without the revenue.\"",
          "source": "Empire State Indivisible's Albany Agenda forum",
          "date": "Feb. 8, 2021",
          "url": "https://www.facebook.com/160250054482729/videos/3844337965604204"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"I would love to see the city take control, but only if we had the revenue to support it.\"",
          "source": "Empire State Indivisible's Albany Agenda forum",
          "date": "Feb. 8, 2021",
          "url": "https://www.facebook.com/160250054482729/videos/3844337965604204"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"The city deserves an MTA that either we have the ability to resource and direct and control or that Albany does what Albany needs to do, which is ensure that it has sufficient investments and transparency and accountability.\"",
          "source": "Empire State Indivisible's Albany Agenda forum",
          "date": "Feb. 8, 2021",
          "url": "https://www.facebook.com/160250054482729/videos/3844337965604204"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"I don't know if the city is at a point right now where we should be taking on additional responsibilities until we have a clear-cut plan as to how we're going to manage it and make sure that it's successful.”",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "no-city-mta": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "“What we should do is expand the MTA board. A member from every borough should be added to the board. We need a lot of voices on the board to ensure that New York City, which really is the feeder for our MTA system, is in place, but no, if we don't have the dollars attached to it, it's the wrong thing to do, in my opinion.”",
          "source": "District Council 37 forum",
          "date": "Jan. 26, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=2040"
        },
        {
          "slug": "scott-stringer",
          "quote": "“It would be great to control the subways but I've crunched the numbers — we can't take on the debt service. We can't take on the debt, it is not practical for us today to take over the MTA.”",
          "source": "District Council 37 forum",
          "date": "Jan. 26, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=2198"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"We don't have a pathway to be able to take over the subways, but we should have a mayor that has more power over the subways.\"",
          "source": "District Council 37 forum",
          "date": "Jan. 26, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=2273"
        },
        {
          "slug": "art-chang",
          "quote": "Chang calls for \"doubling down on our bus systems,\" which includes increasing the number of express buses or on-demand services. ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"We simply cannot afford this...and we don't have the resources to be able to run the MTA the way that it's supposed to be run.\"",
          "source": "District Council 37 forum",
          "date": "Jan. 26, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=2355"
        }
      ]
    },
    "congestion-pricing": {
      "current": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We need to be better stewards of our money, including the money that's going to come in as a result of congestion pricing.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"Part of what we need to do with that money is put it into our subway systems to make sure that they're continuing to run and operate and we have to improve them.”",
          "source": "\"Leading Contenders\" Democratic Debate",
          "date": "June 10, 2021",
          "url": "https://youtu.be/F76gXLE9_PU?t=3043"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We need to have congestion pricing put in place now. We are not suffering from a lack of cars in midtown today, yesterday, the day before. People are coming in and if they all come in by car we can't move. We need people to get back on the subway.”",
          "source": "\"Leading Contenders\" Democratic Debate",
          "date": "June 10, 2021",
          "url": "https://youtu.be/F76gXLE9_PU?t=3066"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We need congestion pricing. We need it now. The Trump administration thwarted us. We can really build back our transportation system with that revenue.”",
          "source": "NYC Mayoral Leading Contenders Debate",
          "date": "June 10, 2021",
          "url": "https://youtu.be/F76gXLE9_PU?t=3083"
        },
        {
          "slug": "eric-adams",
          "quote": "\"Need it now. Also we lockbox all the money goes into transit. Commissioners and others with cars, on the subway system, MetroCard. I use the subway all the time. I think it's important to do it right now.”",
          "source": "NYC Mayoral Leading Contenders Debate",
          "date": "June 10, 2021",
          "url": "https://youtu.be/F76gXLE9_PU?t=3092"
        },
        {
          "slug": "andrew-yang",
          "quote": "“Congestion pricing has been a long time in coming but we have to be mindful of our city's recovery. Right now 80% of midtown commercial real estate buildings are still empty so we have to accelerate the recovery by any means necessary. So I'd be flexible on the timing of adopting congestion pricing in line with the city's return of commuters.”",
          "source": "NYC Mayoral Leading Contenders Debate",
          "date": "June 10, 2021",
          "url": "https://youtu.be/F76gXLE9_PU?t=3114"
        }
      ],
      "no-congestion-pricing": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“New York City is in a crisis, and we need to raise revenue for the city. We always find ways to do that — impact the people who could afford it the least.\"",
          "source": "THE CITY interview ",
          "date": "May 12, 2021"
        }
      ],
      "city-control": [
        {
          "slug": "dianne-morales",
          "quote": "“It’s time for NYC to see redesigned streets.... This includes also seeing a reduction of trucks and cars on streets, offering subsidies and tax breaks to those who find alternate means of travel besides cars and congestion pricing.”",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/5ffa3a10346f087732933590/1610234384320/CBID+Questionnaire+-+Dianne+Morales.pdf"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"My administration will vocally support congestion pricing and work with the state and federal government to implement it as soon as technically feasible.\"",
          "source": "Streetsblog",
          "date": "Dec. 16, 2020",
          "url": "https://nyc.streetsblog.org/2020/12/16/decision-2021-which-mayoral-candidates-support-a-car-free-manhattan/"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"I support congestion pricing not only as a way to raise revenue for transit, but also because it has the added benefit of reducing the number of cars that are on the road and thus lessening emissions. However, we need to make sure the MTA uses this revenue well.\"",
          "source": "Tribeca Citizen",
          "date": "May 24, 2021",
          "url": "https://tribecacitizen.com/2021/05/24/the-candidates-2021-ray-mcguire-for-mayor/"
        }
      ]
    },
    "bqe": {
      "keep-current": [
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "housing": {
    "affordable": {
      "range": [
        {
          "slug": "andrew-yang",
          "quote": "Yang has said that housing built on public land should be 100% affordable at a range of incomes.",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "eric-adams",
          "quote": "Adams wants housing built on public land to be 100% affordable to low- and moderate-income residents.",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"Necessary investments in affordable housing are long overdue. As Mayor, I will.... Create a new mixed-income model that includes deeply affordable units.\"",
          "source": "Twitter",
          "date": "Feb. 4, 2021",
          "url": "https://twitter.com/ShaunDonovanNYC/status/1357385360611954693?s=20"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Much of what is advertised as ‘affordable’ housing is not actually affordable at all. I will abolish all tax breaks for luxury condominiums and focus our resources on housing for those who need it the most.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "low-income": [
        {
          "slug": "dianne-morales",
          "quote": "Morales advocates for government-led social housing on land held in public trust, \"creating a whole new paradigm for how we exist together in the city, and enable everyone to live in dignity.\"",
          "source": "Gothamist",
          "date": "April 1, 2021",
          "url": "https://gothamist.com/news/big-idea-dianne-morales-wants-bring-social-housing-nyc"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“When I'm mayor, my focus will be on deeply affordable housing. What do I mean by that? Less than 30% of median income in New York City. Those are the folks who struggle to make the rent every month.”",
          "source": "Campaign video",
          "date": "",
          "url": "https://www.youtube.com/watch?v=kptU_VAfFRg"
        },
        {
          "slug": "maya-wiley",
          "quote": "“We're going to track it by people's needs. So it's going to include very low and extremely low-income people and ensuring that we have housing for them.”",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We have got to ensure that the next generation of housing we build is actually for the people who need it the most.”",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "art-chang",
          "quote": "\"I'm a huge favor of mixed-income and mixed-use developments. But I think that the focus has to be on creating low income housing.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": " \"We should be building what people can actually afford. And that will look different in every community, but at least it will create stability in every community.\"",
          "source": "THE CITY interview",
          "date": "Sept. 24, 2020"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"I'll double the city's current level of investment, and the majority of that money will go to build deeply affordable housing. What does that mean? That means housing for a family of three earning less than $51,000.\"",
          "source": "McGuire NYC Housing Plan video ",
          "date": "April 1, 2021",
          "url": "https://www.pscp.tv/w/czSGkjFKUkVtcVlCcFZ2RVB8MU95S0FFTkxBQmFLYlivHoY_hN5HUpF6Qwzq3ZdbazK8GaoLCuaGsyZZq2jK"
        }
      ],
      "scale-back": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        }
      ]
    },
    "battery-park-city": {
      "split": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "upgrade": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "\"One idea that I think we should put forth immediately is to take $40 million a year over 10 years from the Battery Park City Authority.... We could bond that money as a way of creating a new revenue stream for NYCHA.\"",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=1831"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "general": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The funding for Battery Park City can help facilitate affordable housing elsewhere.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        }
      ]
    },
    "rad": {
      "maintain-oversight": [
        {
          "slug": "andrew-yang",
          "quote": "\"I think that a lot of the friction we're describing is because too many NYCHA residents don't feel like they have a say...the NYCHA board, instead of being minority tenants, should be majority tenants.\"",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "\"I'm going to give [NYCHA residents] an attorney that they are going to interview and decide — not a city intern attorney, but someone in private practice that we would pay for so they can be in the room negotiating these important issues such as RAD.\"",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=807"
        }
      ],
      "private": [
        {
          "slug": "dianne-morales",
          "quote": "In her administration, Morales vows, \"There's no sweet deals or handoffs to private developers...we've got to focus on retrofitting our buildings and investing in the capital repair.\"",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "\"The principles have to be about keeping public housing public, and that's one of the concerns around RAD.\"",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=1624"
        },
        {
          "slug": "scott-stringer",
          "quote": "“Every time we move to privatize public housing, it comes with a sense that we have failed . . . But when we look at the different models we're forced to use right now, it's because of the lack of investment on a federal level.”",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=1811"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"It's an attempt to have one-size-fits-all. RAD is not going to work in all of NYCHA buildings.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“I don’t just see RAD as just private management, I see RAD as private ownership to developers.... We need to create opportunities for those NYCHA residents that may have the ability to own something, to give them ownership, to give them control of their own developments and create better for themselves.\"",
          "source": "THE CITY interview",
          "date": "Sept. 24, 2020"
        }
      ],
      "yes-rad": [
        {
          "slug": "kathryn-garcia",
          "quote": "\"When I went and saw developments that had gone through the RAD process at Ocean Bay or at Campos II, the tenants were extremely happy.\"",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=1226"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“RAD does not require privatization. It is a way to get Section 8 resources into public housing...we need a reset on RAD.”",
          "source": "Housing Conservation Coordinators' forum",
          "date": "Dec. 8, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=2051"
        }
      ]
    },
    "upzone": {
      "areawide": [
        {
          "slug": "andrew-yang",
          "quote": "\"Housing costs and rent are going up for more and more Americans while income stagnates. Relaxing zoning laws and NIMBYism would help in many areas, as would micro-apartments and innovative approaches to communal housing.\"",
          "source": "Twitter",
          "date": "Aug. 11, 2019",
          "url": "https://twitter.com/andrewyang/status/1160509800846958594?lang=en"
        },
        {
          "slug": "dianne-morales",
          "quote": "\"We need to fully restore funding cuts to affordable housing, change our outdated zoning rules.\"",
          "source": "Twitter",
          "date": "Oct. 30, 2020",
          "url": "https://twitter.com/Dianne4NYC/status/1322331621882765312?s=20"
        },
        {
          "slug": "eric-adams",
          "quote": "“We have our upzoning wrong. We've upzoned in poorer communities and displaced poor residents for richer communities, and I would do just the opposite. I will upzone in affluent areas where you have transit, rich communities, great schools, access to healthy food. So we need to reverse that.”",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://wbai.org/archive/program/episode/?id=20766"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We also need to be creative — you know, end the zoning that blocks us from really creating more density.”",
          "source": "Open New York Conversation with Kathryn Garcia",
          "date": "Dec. 29, 2020",
          "url": "https://youtu.be/TDskw7nBn_M?t=282"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"We must prioritize building permanently and deeply affordable housing for low income and extremely low income people across the city, not prioritizing certain zoning designations.\"",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/60046bb7ce24650c882972ab/1610902455238/FINAL+Maya+Wiley+CBID+2021+Mayoral+Candidate+Questionnaire.pdf"
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer seeks to require affordable housing in new development regardless of whether zoning changes are sought. “If you’re going to build in New York City, you will provide affordability that is sustainable.... No longer will developers be able to use affordable housing as a bargaining chip with communities.” ",
          "source": "Comptroller website",
          "date": "Jan. 29, 2020",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-proposes-sweeping-universal-affordable-housing-requirement-for-all-new-construction-in-the-city/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"We, more and more, have seen political divisions in this city stop the potential to grow our economy and to create more affordable housing.... The only way we’re going to be able to solve that is to have a mayor who can create what I would call a progressive coalition for equitable growth.\"",
          "source": "Bloomberg Opinion",
          "date": "March 1, 2021",
          "url": "https://www.bloomberg.com/opinion/articles/2021-03-01/how-shaun-donovan-would-run-new-york"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "McGuire's campaign says he \"will advance a citywide rezoning that will drive new residential construction.\"",
          "source": "Campaign website",
          "date": "April 1, 2021",
          "url": "https://www.rayformayor.com/housing"
        }
      ],
      "some-yes": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"Jamaica is one area that is ripe for redevelopment. Jamaica already has the requisite infrastructure for upzoning, including a variety of mass transit options, local colleges and universities, and a thriving downtown.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "In addition to creating more affordable housing, Chang calls for factoring climate change. \"Where we spend our precious dollars on increasing density has to be in some of these higher land areas.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "immigration": {
    "cash": {
      "yes-cash": [
        {
          "slug": "andrew-yang",
          "quote": "\"The pandemic exposed how many New Yorkers live on the edge of ruin... Getting more money directly into people’s pockets was once radical and is now mainstream.\"",
          "source": "USA TODAY",
          "date": "March 3, 2021",
          "url": "https://www.usatoday.com/story/money/2021/03/03/universal-basic-income-andrew-yang-guaranteed-more-cities-test-monthly-check/6890858002/"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia supports providing residents with cash assistance regardless of immigration status.",
          "source": "City & State NY/Documented",
          "date": "March 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "maya-wiley",
          "quote": "“Remember Census 2020. Remember when we asked every New Yorker — whether they had documentation or not — to put their names on the line.… We asked them to count because that would bring more money to us.... And now the question is, do they count? Because we had a historic census count to bring more federal dollars to the state.”",
          "source": "Twitter",
          "date": "March 24, 2021",
          "url": "https://twitter.com/mayawiley/status/1374751725274431491"
        },
        {
          "slug": "scott-stringer",
          "quote": "“19% of NYC's frontline workers are non-citizens or undocumented -- risking their lives while being excluded from life-saving state and federal support. As Mayor, I'll fight to ensure we #FundExcludedWorkers.”",
          "source": "Twitter",
          "date": "March 5, 2021",
          "url": "https://mobile.twitter.com/scottmstringer/status/1367883732930166785"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"Under my Equity Bonds program, any child born into poverty, regardless of immigration status, can go to school knowing that ~$50,000 is waiting for them before entering the workforce or pursuing higher education.\"",
          "source": "",
          "date": "Jan. 19, 2021",
          "url": "https://twitter.com/ShaunDonovanNYC/status/1351654605118177283"
        },
        {
          "slug": "art-chang",
          "quote": "Chang noted in addition to government cash assistance, enabling mutual-aid or a \"super network of mutual aid socities\" to distribute such funds would be effective. \"There are going to be legal constraints on what the government can do. But there are many fewer on private individuals.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "no-cash": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        }
      ],
      "special-cash": [
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer said the aid should include cash assistance as well as grocery hand-outs or hot meals. \"We do need to make sure we don't leave our undocumented immigrants behind.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"We can create other forms of funding for undocumented immigrants through specific programs.\"",
          "source": "THE CITY Interview",
          "date": "May 3, 2021"
        }
      ]
    },
    "attorney": {
      "yes-counsel": [
        {
          "slug": "andrew-yang",
          "quote": "Yang wrote on his campaign website that he supports expanding access to and funding for the New York Immigrant Family Unity Project and other similar immigration legal services.",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.yangforny.com/policies/a-sanctuary-city/"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales supports increased funding for the New York Immigrant Family Unity Project in order to provide attorneys for non-detained immigrants.",
          "source": "City & State New York and Documented",
          "date": "April 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "eric-adams",
          "quote": "Adams supports expanding funding for immigration legal services, including the New York Immigrant Family Unity Project.",
          "source": "City & State NY/Documented",
          "date": "April 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia is in favor of contributing to the New York Immigrant Freedom Fund, which pays immigration bonds for detainees in need.",
          "source": "City & State NY/Documented",
          "date": "April 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley wants to back the New York Immigrant Family Unity Project, the public defender system for NYC immigrants in detention facing deportation.",
          "source": "City & State NY/Documented",
          "date": "April 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I’m calling for the City to protect these New Yorkers and eliminate the carve-out that limits access to immigrant legal services because if we believe in due process for all people, we can’t be in the business of choosing who deserves a truly fair day in court.”",
          "source": "City Comptroller news release",
          "date": "Feb. 21, 2019",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-investigation-reveals-huge-increases-in-ice-enforcement-in-nyc-leaving-families-in-fear/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan's campaign says he supports more resources and funding for legal services to help immigrants.",
          "source": "City & State NY/Documented",
          "date": "April 12, 2021",
          "url": "https://documentedny.com/2021/04/13/heres-what-the-top-mayoral-candidates-say-theyll-do-for-immigrant-new-yorkers/"
        },
        {
          "slug": "art-chang",
          "quote": "\"If we are truly in a sanctuary city, and then we need to prevent law-abiding immigrants from being deported, period. This is not about paying for immigration lawyers. This is about preventing deportation.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "no-counsel": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        }
      ],
      "continue-counsel": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The right to counsel is an important thing. It's merely a question of cost.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    },
    "basement": {
      "allow-more": [
        {
          "slug": "andrew-yang",
          "quote": "Yang's campaign website says he will pick up where the current mayor left off with a basement apartment pilot program, as well as support changes in state law and city code to promote more such units.",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.yangforny.com/policies/long-term-permanently-affordable-housing"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "“There is a lot of work to be done quickly with the Department of City Planning: making better use of existing housing infrastructure by getting rid of single-family zoning; ensuring that accessory dwelling and basement units are legal, safe and affordable.”",
          "source": "2021 VOCAL-NY Questionnaire Responses Homelessness and Housing",
          "date": "",
          "url": "https://static1.squarespace.com/static/5edbd1827536f464a00c32de/t/605235dbc28d8e2b6d5923d1/1616000475572/2021+Mayoral+responses.pdf"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We also need to be creative, you know, end the zoning that blocks us from really creating more density, legalize basement apartments make it so that we can have single room occupancy again in a way that's safe.\"",
          "source": "Open New York interview",
          "date": "Dec. 29, 2020",
          "url": "https://youtu.be/TDskw7nBn_M?t=281"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer says he intends to help property owners to transform their basement and garage spaces to rental apartments.",
          "source": "\"Scott Stringer’s Mayoral Plans\"",
          "date": "Feb. 25, 2021",
          "url": "https://stringerformayor.com/wp-content/uploads/2021/02/housing_final.pdf"
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer said more housing is needed but dwellings must comply with zoning restrictions. \"People have bought homes on residential streets, in reliance on being protected by the zoning laws. So if all of a sudden, all their neighbors are allowed to convert into apartments, then it changes the character of the neighborhood.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"We should definitely do this while we preserve safety.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "“My plan will also make it easier for homeowners to earn income from the property by converting existing spaces into new rental apartments, that means updating our zoning rules to allow for basement and garage apartments and other necessary dwelling.”",
          "source": "McGuire NYC Housing Plan",
          "date": "April 1, 2021",
          "url": "https://youtu.be/pEvYpwMKi_k?t=1624"
        }
      ],
      "convert-illegal": [
        {
          "slug": "eric-adams",
          "quote": "“Thousands of New Yorkers live in SROs and basement apartments, or in single family zones where leasing accessory units is illegal. By allowing for all of these units to be built or legally used, we can add hundreds of thousands of affordable apartments.”",
          "source": "Twitter",
          "date": "May 28, 2021",
          "url": "https://twitter.com/ericadamsfornyc/status/1398450682928185352?s=21"
        }
      ]
    },
    "elections": {
      "no-voting": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“I do not support the current proposed legislation for allowing non-citizens voting powers in municipal races.”",
          "source": "City Limits",
          "date": "March 10, 2021",
          "url": "https://citylimits.org/2021/03/10/what-new-york-citys-mayoral-candidates-are-saying-about-immigration/"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"I do believe that it's important for people to come here become a citizen and then vote.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "allow-all": [
        {
          "slug": "dianne-morales",
          "quote": "“Yes! Nearly one million New Yorkers are unable to vote, despite paying taxes and being impacted by the daily decisions of the city government. Especially in a city like ours, where we know our excluded workers are often our essential workers, they deserve a voice in the system.”",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/5ffa3a10346f087732933590/1610234384320/CBID+Questionnaire+-+Dianne+Morales.pdf"
        },
        {
          "slug": "art-chang",
          "quote": "\"The vast majority of non citizens are also taxpayers. They contribute to our city's income revenue, they also use our city services. They should have a say in who gets to represent them.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "allow-some": [
        {
          "slug": "eric-adams",
          "quote": "\"Say it loud and say it clear: Immigrants are welcome here. I'm proud to support expanded voting rights in municipal elections for lawful permanent residents of our city.\"",
          "source": "Twitter",
          "date": "March 10, 2021",
          "url": "https://twitter.com/BKBoroHall/status/1314919911425282055"
        },
        {
          "slug": "maya-wiley",
          "quote": "“YES. All residents of New York City should have the right to vote. Just as non-citizens were able to vote in school board elections of the past, they should be able to vote in municipal elections of the future.”",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/60046bb7ce24650c882972ab/1610902455238/FINAL+Maya+Wiley+CBID+2021+Mayoral+Candidate+Questionnaire.pdf"
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer said he supports expanding voting rights in municipal elections to all New Yorkers with green cards or work authorizations.",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/5ffa3a22b796f940d485acee/1610234403279/Scott+Stringer+CBID+Questionnaire.pdf"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Citing his father as an example, Donovan agrees with allowing noncitizen New York City residents to vote in municipal elections.",
          "source": "Central Brooklyn Independent Democrats questionnaire",
          "date": "March 10, 2021",
          "url": "https://static1.squarespace.com/static/5e2de03be9ce95784dff0326/t/5ffa39e277693f06a3db1178/1610234338200/Shaun+Donovan+-+CBID+Questionnaire.pdf"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "labor": {
    "federal-aid": {
      "extend-ui": [
        {
          "slug": "andrew-yang",
          "quote": "“Most everyone knows that if I had my way, we’d all be getting $1,000 a month from the federal government,” Yang said in reference to his proposed universal basic income plan, which he would target to NYC's neediest. “I’m thrilled to make it happen in the biggest, greatest city in the country.”",
          "source": "Bloomberg CityLab",
          "date": "Jan. 28, 2021",
          "url": "https://www.bloomberg.com/news/articles/2021-01-28/what-s-in-andrew-yang-s-ubi-proposal-for-nyc"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "Adams' campaign told the Daily News he would expand tax credits for low-income working people and make the benefit available for the recently unemployed.",
          "source": "New York Daily News",
          "date": "",
          "url": "https://www.nydailynews.com/news/politics/new-york-elections-government/ny-eric-adams-mayoral-race-tax-credit-plan-20210301-uijpy5hbbrbkhhbif6ww4f4go4-story.html"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We need to grow. That is part of what gets us out of this, which has meant strategic investments in working with the private sector to provide low-interest loans to our restaurants and to our small businesses. We need them back. They're huge generators of employment.”",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://vimeo.com/516504470"
        },
        {
          "slug": "art-chang",
          "quote": "\"We should have government programs that employ people. And we should also help employers bring back their employees, especially small businesses. But for everybody else, we need unemployment benefits.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "wage-subsidies": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "\"I proposed the City create a $1 billion stimulus fund for small businesses, and nonprofits that would distribute grants between $20,000 and $100,000 to organizations for payroll, back rent, to rehire employee who were let go, to pay for costs incurred from COVID-19 safety renovations, and more.\"",
          "source": "Statement to THE CITY",
          "date": ""
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We want to encourage people to come to the office safely. We want to encourage workers in restaurants and other service industries that have been shut down to return to work.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"I've identified what I call a comeback accelerator plan, which gives wage subsidies to 50,000 small businesses. We’ll pay 50% of the workers’ salary for one year by jumpstarting the economy. It’s going to cost me 900-plus-million dollars over two budget years, which I can pay for by using the existing federal and state funds.”",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://vimeo.com/516504470"
        }
      ],
      "gov-jobs": [
        {
          "slug": "maya-wiley",
          "quote": "“I have based my plan and my program on what we have learned in history, which is that when we are in an economic crisis, we have to find a way to invest in our people, put dollars in our pockets and make sure that we are stimulating the economy.”",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://vimeo.com/516504470"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "more-loans": [
        {
          "slug": "shaun-donovan",
          "quote": "\"We will deploy capital to small businesses in neighborhood commercial areas, dispersing small loans to viable retail businesses to help them retool and expand as New York City emerges from the pandemic-driven recession.\"",
          "source": "The Plan for the City of New York",
          "date": ""
        }
      ]
    },
    "unions": {
      "balance": [
        {
          "slug": "andrew-yang",
          "quote": "\"I'm going to wring the budget of everything that is not people, to try and balance the budget in a way that does not affect you and yours.”",
          "source": "DC37 Mayoral Forum",
          "date": "Jan. 25, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=7084"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "“I would work with labor in order to come to a conclusion or come to an agreement that was mutually agreeable” on raises for city workers.",
          "source": "Citizens Budget Commission mayoral candidate forum",
          "date": "Feb. 24, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“You have to work with labor because they are the ones who actually end up doing the job. And so, when you are collaborative, you can find savings, which has historically been done.”",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://vimeo.com/516504470"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I've stood there with you, and if I'm elected mayor, together we will continue a partnership that honors your service, that does not threaten your jobs; it does not threaten the work that you do. We will be equal, respected partners as we bring the city back.”",
          "source": "DC37 Mayoral Forum",
          "date": "Jan. 25, 2021",
          "url": "https://youtu.be/vapNaAOVzU8?t=7322"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan's campaign says he will save money while “avoiding layoffs by establishing a general hiring freeze — excluding teachers and essential public safety positions — as well as a general wage freeze, and by consolidating pension and benefit funds, starting with all non-uniform and non-UFT funds.”",
          "source": "The Plan for the City of New York",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        }
      ],
      "municipal-second": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"When negotiating with labor unions, we have to look at how we can trim down the cost of our workforce. So we can't simply do giveaways to any interest group, and that includes labor unions, contractors and otherwise.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"NYPD's PBA is an example of a union that needs changes in its bargaining.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "municipal-first": [
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ]
    },
    "wage": {
      "auto-increase": [
        {
          "slug": "andrew-yang",
          "quote": "\"If I had a choice between something like universal basic income and a higher minimum wage, I would choose universal basic income. But if I don't get universal basic income, then I'm all for raising the minimum wage.\" ",
          "source": "Pitchfork Economics podcast",
          "date": "April 3, 2021",
          "url": "https://www.businessinsider.com/andrew-yangs-on-universal-basic-income-versus-higher-wages-2021-4"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales seeks a guaranteed minimum income. “It’s really the idea of raising the floor for some of the most vulnerable and marginalized people in New York City.”",
          "source": "NY1",
          "date": "Feb. 3, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/02/24/nyc-elections-2021-whos-running-dianne-morales-basic-income-proposal-cash-payments-services"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“It's nearly impossible to live on $15 an hour here, in the city of New York. And honestly, the federal minimum wage should be tied to inflation, as it once was. We need to work with our small businesses to understand and take into account what when we are making worker changes.”",
          "source": "THE CITY interview",
          "date": "April 13, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "source": "Twitter",
          "date": "March 31, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan’s campaign says he will create “a wage board to set fair terms for compensation” for climate adaptation workers that replicates “the successful process to increase the minimum wage in New York State.\"",
          "source": "The Plan for the City of New York",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        },
        {
          "slug": "art-chang",
          "quote": "\"The rate of inflation should be the rate of inflation for everything.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "no-increase": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "\"Our waiters were making amazing tips. Some waiters were making $700, $800 a day, on tips. These waiters were making $8 an hour. When the $15-an-hour rule came, we had to let go about 50 of our employees because we just couldn't afford it.\"",
          "source": "NYC Hospitality Alliance Mayoral Forum",
          "date": "April 12, 2021",
          "url": "https://youtu.be/StAqy0BE0tM?t=3962"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The last thing you want to do is increase it again, which will hurt small businesses...they simply couldn't afford it.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "review-increase": [
        {
          "slug": "eric-adams",
          "quote": "\"We should also support efforts to increase the minimum wage.\"",
          "source": "CUNY Urban Food Policy Institute ",
          "date": "",
          "url": "https://www.cunyurbanfoodpolicy.org/nyc-mayoral-candidate-eric-adams"
        }
      ]
    },
    "gig": {
      "flex-reclassify": [
        {
          "slug": "andrew-yang",
          "quote": "\"The California bill to reclassify contract workers for companies like Uber as employees, not contractors, is a positive step. In many cases the companies have as much or more control than traditional employers.\"",
          "source": "Twitter",
          "date": "Sept. 11, 2019",
          "url": "https://twitter.com/andrewyang/status/1171665405301219328?lang=en"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I will work to ensure that all workers are paid fairly, are able to secure their pay without hassle or cheating and have access to benefits — whether they are a freelancer, an employee, or an undocumented worker.”",
          "source": "Community Service Society NY questionnaire",
          "date": "",
          "url": "https://www.cssny.org/voter-guide-2021/candidate/shaun-donovan"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"If all of a sudden everyone's classified as an employee...costs will go up to businesses everywhere. And those costs will then be passed along to consumers.'\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "reclassify": [
        {
          "slug": "dianne-morales",
          "quote": "Morales’ campaign says she would push for creating paid family leave, maternity leave, and sick leave to independent contractors and gig workers. She would also create a platform cooperative and digital democracy agenda.",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.dianne.nyc/healthcare"
        },
        {
          "slug": "eric-adams",
          "quote": "\"First of all, I will push for gig-economy workers to have all of the rights and benefits of traditional employees.\"",
          "source": "Community Service Society NY questionnaire",
          "date": "",
          "url": "https://www.cssny.org/voter-guide-2021/candidate/eric-l-adams"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“This is really got to be done at the state level. It is nearly impossible to do this at the city level. We can do it in some cases in areas where that business requires permits or licenses, so that's why we've been able to step in.”",
          "source": "THE CITY interview",
          "date": "April 13, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "“Gig-economy workers have played an important role in keeping our city running throughout the COVID crisis. I support the right of all workers to organize, and I support the classification of app-based drivers as employees, entitled to the rights and protections they deserve.\"",
          "source": "Community Service Society NY questionnaire",
          "date": "",
          "url": "https://www.cssny.org/voter-guide-2021/candidate/maya-d-wiley"
        },
        {
          "slug": "scott-stringer",
          "quote": "The Stringer campaign calls for strengthening workforce protections for independent contractors and says Stringer will fight misclassification of workers.",
          "source": "NYC Comptroller website",
          "date": "March 15, 2021",
          "url": "https://comptroller.nyc.gov/reports/our-crisis-of-care/#7-strengthen-workforce-protections-for-independent-contractors-and-fight-misclassification"
        }
      ],
      "no-reclassify": [
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "criminal-justice": {
    "rikers": {
      "change-timeline": [
        {
          "slug": "andrew-yang",
          "quote": "“We need to re-examine the four borough jail project really from A to Z because I've met many New Yorkers who did not feel properly included in that plan. … I do think that we should be moving to close Rikers as soon as possible, but we need a better plan that more community members are on board with in terms of what comes next.”",
          "source": "NY1’s “Inside City Hall",
          "date": "Jan. 14, 2021",
          "url": "https://youtu.be/794jxBj__OA?t=4419"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"We have to close Rikers Island. It is a human rights violation, what is happening at Rikers.… There is a plan in place. It's a plan that will be implemented, and.... I support the plan.\"",
          "source": " Queens Post Podcast",
          "date": "March 19, 2021",
          "url": "https://youtu.be/ocLAfSnbMgg?t=889"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I was the first elected official to say shut it down and close Rikers. I was the first.”",
          "source": "NYC Criminal Justice and Reentry Mayoral Forum",
          "date": "April 5, 2021",
          "url": "https://youtu.be/b8Hj1Lm6VeA?t=549"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer said the it is hard to project the city's tax base and its ability to pay for new jails: \"The cost of these new jails looks to be astronomical.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "reevaluate": [
        {
          "slug": "curtis-sliwa",
          "quote": "Sliwa said he wouldn’t close Rikers when he was asked.",
          "source": "WABC Radio Republican Debate",
          "date": "March 31, 2021",
          "url": "https://youtu.be/9pnNmm7iakQ?t=4682"
        },
        {
          "slug": "fernando-mateo",
          "quote": "“I wouldn't shut Rikers Island down, I would reform it.... I would change the name, and I would make sure that we make it a rehabilitation center.”",
          "source": "Republican Mayoral Debate",
          "date": "March 31, 2021",
          "url": "https://youtu.be/9pnNmm7iakQ?t=2307"
        }
      ],
      "close-all": [
        {
          "slug": "dianne-morales",
          "quote": "“I've pledged to close Rikers and to open NO new prisons or jails as we dismantle a ‘justice’ system built to criminalize Black and Brown communities.”",
          "source": "Twitter",
          "date": "Nov. 9, 2020",
          "url": "https://twitter.com/Dianne4NYC/status/1325982202799263751"
        },
        {
          "slug": "art-chang",
          "quote": "\"If you build it, you will have to fill it. Do we actually know that we need an expansion in our jail system?\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“I am opposed to spending $11 billion on jails.... There are so many other things that we can utilize those funds for.… In the short term, it will continue to be on Rikers.”",
          "source": "THE CITY interview",
          "date": "Sept. 24, 2020"
        }
      ],
      "as-proposed": [
        {
          "slug": "eric-adams",
          "quote": "In backing a new jail for downtown Brooklyn, Adams urged \"rehabilitation over incarceration, providing workforce and educational opportunities for inmates, providing mental health services and mindfulness training to those struggling with trauma, as well as finally addressing the taboo around the prevalence of people with learning disabilities in our jails.\"",
          "source": "Statement as borough president",
          "date": "July 9, 2019",
          "url": "https://www.brooklyn-usa.org/bp-adams-statement-on-city-council-vote-to-close-rikers-island-and-open-borough-based-jail-system/"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“I do believe that we need to close Rikers. I do believe that you know this is the opportunity to fundamentally change what happens there.”",
          "source": "NYC Criminal Justice and Reentry Mayoral Forum",
          "date": "April 5, 2021",
          "url": "https://youtu.be/b8Hj1Lm6VeA?t=1330"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I would finally close Rikers within my time as mayor.”",
          "source": "Uptown Community Democrats Present: NYC Mayoral Candidate Forum",
          "date": "Jan. 15, 2021",
          "url": "https://youtu.be/GDHsh2cdHQo?t=3564"
        }
      ]
    },
    "solitary": {
      "ban-entirely": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "“Solitary confinement is inhumane, and I urge Gov. Cuomo to sign #HALTSolitary immediately.”",
          "source": "Twitter",
          "date": "March 18, 2021",
          "url": "https://twitter.com/Dianne4NYC/status/1372657012597784577"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We need to ensure that there is no solitary confinement.”",
          "source": "NYC Criminal Justice and Reentry Mayoral Forum",
          "date": "April 5, 2021",
          "url": "https://youtu.be/b8Hj1Lm6VeA?t=2680"
        },
        {
          "slug": "maya-wiley",
          "quote": "“I want to make sure there's no solitary confinement.”",
          "source": "Empire State Indivisible's Mayoral Candidate Forum",
          "date": "Feb. 8, 2021",
          "url": "https://www.facebook.com/watch/live/?v=3844337965604204&ref=watch_permalink"
        },
        {
          "slug": "scott-stringer",
          "quote": "Asked if solitary confinement should be ended, Stringer replied \"Of course, yes.\"",
          "source": "Mental Health Town Hall, Citizen Action of New York",
          "date": "Dec. 15, 2021",
          "url": "https://youtu.be/XWzCsQuHZn0?t=5355"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I think they need [penal institutions] to be something else. Reimagining them is going to be a powerful part of that, and that includes getting rid of solitary confinement.”",
          "source": "NYC Criminal Justice and Reentry Mayoral Forum",
          "date": "April 5, 2021",
          "url": "https://youtu.be/b8Hj1Lm6VeA?t=2739"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "no-ban": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "Adams said he would end solitary confinement only for non-violent detainees.",
          "source": "Mental Health Town Hall, Citizen Action of New York",
          "date": "Dec. 15, 2021",
          "url": "https://youtu.be/XWzCsQuHZn0?t=5365"
        }
      ],
      "maintain-hours": [
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer said solitary confiment should be discouraged but not banned since \"there might be limited circumstances where it's necessary.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    },
    "drug": {
      "pot-more": [
        {
          "slug": "andrew-yang",
          "quote": "“I'm for the total decriminalization of cannabis and marijuana. … I'm for the decriminalization of many of these prescription opioids that, frankly, the drug companies have generated billions of dollars of blood money from. … I'm for legalization of psilocybin mushrooms, and I'm open to the public policy impact of legalizing other substances.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=5623"
        },
        {
          "slug": "dianne-morales",
          "quote": "Asked about decriminalizing small amounts of all drugs, including cannabis, heroin, and crack, cocaine, Morales said, “We need to move toward that in the response to the war on drugs, so it's all of those things.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=5502"
        },
        {
          "slug": "maya-wiley",
          "quote": "“We have to start, obviously, with where we have already a lot of public support with marijuana.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=3529"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We need to make sure that there's opportunity for whether it's morphine or different drugs. We can't just simply incarcerate.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=2159"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I am certainly for decriminalizing certain substances.... I do have some concerns about decriminalizing completely into all substances. ... I do have concerns about the devastation I've seen with highly, highly addictive and deadly drugs where even small amounts can have life-altering consequences and even cause death.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=3333"
        },
        {
          "slug": "art-chang",
          "quote": "\"We should stop criminalizing addiction. That people who are addicts have a different problem. It's not a criminal problem. It is a health problem.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "pot-only": [
        {
          "slug": "eric-adams",
          "quote": "“I support 100% legalization of marijuana.... I don't support legalizing crack, cocaine. It is devastating when you see what it does. I don't support the legalization of heroin. I don't support the legalization of, you know, those hard, serious drugs at all.”",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=5546"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"I am for decriminalizing marijuana. I think that is absolutely fine, but there are other substances — not only fentanyl, but even things like cocaine — where you don't know how your body's going to react.\"",
          "source": "VOCAL-NY’s Mayoral Candidate Forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=3428"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "trial": {
      "release": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“While supervised release is a good step for reducing the harms and costs of jail, it should not be used for those who do not require supervision, because community supervision (including more intrusive forms like parole and probation) can become trip-wires to more incarceration and counterproductive involvement with the justice system.”",
          "source": "Statement to THE CITY",
          "date": "April 29, 2021"
        }
      ],
      "supervised": [
        {
          "slug": "eric-adams",
          "quote": "Adams recommended expanding the city’s supervised release programs to include a “broader range of non-violent crimes.”",
          "source": "The Brooklyn Eagle",
          "date": "July 9, 2019",
          "url": "https://brooklyneagle.com/articles/2019/07/09/brooklyn-borough-president-calls-for-smaller-boerum-hill-jail-with-yoga-for-those-incarcerated/"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“It really has happened that the nonprofit sector being stepping up and then also using technology, so they can have supervised release. You know, this is, we don't want people to be in jail. I mean, there are some people who like obviously need to be there but, for the most part, you're waiting trial. That you should be presumed innocent to a certain hearings, like the presumption is you are presumed innocent.”",
          "source": "THE CITY interview ",
          "date": "April 13, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "\"The data has not shown a correlation between supervised release and crime, especially violent crime. \"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"We need mentors and love agents that work to help folks deal with the issues that led them to committing a crime.\"\n",
          "source": "THE CITY Interview",
          "date": "May 3, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "jail": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"When you have a serious crime take place, you can't just release the perpetrator and allow him or her to commit another crime.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "taxes": {
    "vacancy": {
      "yes-vacancy": [
        {
          "slug": "andrew-yang",
          "quote": "\"I do think the city should be considering things like a pied-a-terre tax that would generate hundreds of millions of dollars.\"",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "March 25, 2021",
          "url": "https://cbcny.org/newsroom/managing-nycs-fiscal-crisis"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales has said she would increase taxes on pieds-a-terre as well as luxury units that developers keep vacant for tax write-offs.",
          "source": "The Root",
          "date": "Jan. 11, 2021",
          "url": "https://www.theroot.com/mayoral-candidate-dianne-morales-doesnt-want-to-return-1846012365"
        },
        {
          "slug": "eric-adams",
          "quote": "Adams has proposed a “pied-a-terre tax surcharge\" on all nonprimary luxury residences worth $5 million or more.",
          "source": "\"Real Recovery NYC\" plan",
          "date": "",
          "url": "https://www.brooklyn-usa.org/wp-content/uploads/2020/06/Real-Recovery-NYC-June-2020-Final.pdf"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley’s campaign plan includes imposing a “pied a terre” tax as part of new revenue sources.",
          "source": "Campaign website",
          "date": "",
          "url": "https://mayawileyformayor.com/plan-to-end-evictions-keep-new-yorkers-in-their-homes-and-fight-homelessness/"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We need this money that will actually make those properties even more valuable because the city with a strong subway or transportation base, the city that is safe, a city that builds park space...enhances the value of those second homes.… Part timers should be paying their fair share, especially people worth hundreds and hundreds of millions of dollars.\"",
          "source": "The Brian Lehrer Show",
          "date": "March 18, 2019",
          "url": "https://www.wnyc.org/story/the-brian-lehrer-show-2019-03-18"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"These part time residents aren't paying their fair share of taxes to run the city.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "intl-only": [
        {
          "slug": "kathryn-garcia",
          "quote": "She “would hate to add more taxes in New York City in general, but we got to pay for things.”",
          "source": "THE CITY interview ",
          "date": "April 13, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "Chang said international part-time residents need to pay taxes so that they are \"contributing to the fabric of the community.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "no-vacancy": [
        {
          "slug": "shaun-donovan",
          "quote": "\"We should be looking at our property tax system, which is actually the most regressive tax in the city. And looking not just at a pied-a-terre tax, but at more fundamental reform in the property tax system.\"",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 25, 2021",
          "url": "https://cbcny.org/newsroom/managing-nycs-fiscal-crisis"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "assessments": {
      "tax-more": [
        {
          "slug": "andrew-yang",
          "quote": "\"Some NYC homeowners in poorer neighborhoods are paying seven times the effective property tax as people that own luxury apartments in Manhattan. Property tax reform is one of the great opportunities to unlock billions of dollars of value and make NYC fairer and more equitable.\"",
          "source": "Twitter",
          "date": "Feb. 17, 2021",
          "url": "https://twitter.com/andrewyang/status/1362019064424652802?lang=en"
        },
        {
          "slug": "dianne-morales",
          "quote": "\"We should be looking at property tax and land value tax, and doing things differently with those revenue sources as well.\"",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://cbcny.org/newsroom/managing-nycs-fiscal-crisis"
        },
        {
          "slug": "eric-adams",
          "quote": "\"New York City’s property tax system is fundamentally unfair, allowing wealthy people in Manhattan high-rises to pay significantly less than lower-income and middle-class, single-family homeowners in the outer boroughs. We need to shift the tax burden off renters and homeowners in less affluent areas to the owners of pricey apartments in wealthy areas.\"",
          "source": "Commercial Observer",
          "date": "April 29, 2021",
          "url": "https://commercialobserver.com/2021/04/the-race-to-gracie-mansion-interview-with-nyc-mayoral-candidate-eric-adams/"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“Literally, two buildings right next to each other could pay wildly different property taxes.... We need to just scrape the whole system. Starts with everything as a true market value.... And the third assessment, choose our assessment off of that.\"",
          "source": "THE CITY interview ",
          "date": "April 21, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "“I would follow the commission’s lead and propose a plan that is revenue neutral.… But the wealthy should pay their fair share, which is why I’m proposing raising property taxes on the wealthiest New Yorkers.”",
          "source": "New York Daily News",
          "date": "April 11, 2021",
          "url": "https://www.nydailynews.com/news/politics/nyc-elections-2021/ny-nyc-property-taxes-reform-de-blasio-yang-adams-stringer-wiley-garcia-20210412-s7rtvp22ojhqvgewhu3hso7kqu-story.html"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I would follow the commission’s lead and propose a plan that is revenue neutral.…But the wealthy should pay their fair share, which is why I’m proposing raising property taxes on the wealthiest New Yorkers.”",
          "source": "New York Daily News",
          "date": "April 11, 2021",
          "url": "https://www.nydailynews.com/news/politics/nyc-elections-2021/ny-nyc-property-taxes-reform-de-blasio-yang-adams-stringer-wiley-garcia-20210412-s7rtvp22ojhqvgewhu3hso7kqu-story.html"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“My focus is really on making the system simpler and more transparent, but also more equitable, so that we are not disproportionately putting the burden of property taxes on rental housing, particularly in the lowest income, Black and Brown communities.\"",
          "source": "New York Daily News",
          "date": "April 11, 2021",
          "url": "https://www.nydailynews.com/news/politics/nyc-elections-2021/ny-nyc-property-taxes-reform-de-blasio-yang-adams-stringer-wiley-garcia-20210412-s7rtvp22ojhqvgewhu3hso7kqu-story.html"
        },
        {
          "slug": "art-chang",
          "quote": "Chang proposed changing tax assessments when there is a change of ownership for a property. \"The perfect time having the least impact on everybody is to do tax transitions during a change in ownership.\"",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We need a fair system across the board. One type of property ownership should not be favored over another.\" ",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "“My approach would be to fix our property tax system through legislative action in Albany.\"",
          "source": "New York Daily News",
          "date": "April 11, 2021",
          "url": "https://www.nydailynews.com/news/politics/nyc-elections-2021/ny-nyc-property-taxes-reform-de-blasio-yang-adams-stringer-wiley-garcia-20210412-s7rtvp22ojhqvgewhu3hso7kqu-story.html"
        }
      ],
      "tax-less": [
        {
          "slug": "curtis-sliwa",
          "quote": "“I will also finally deliver much-needed property tax reform, which will provide economic relief to millions of low- and middle-income residents.... By finally making private, wealthy universities and businesses pay their fair share, I will deliver millions of dollars in tax relief to NYC residents.”",
          "source": "Campaign website",
          "date": "",
          "url": "https://sliwaforny.com/issues/property-taxes/"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"City suffers from a culture of overtaxing and generally that falls on minority communities.\"",
          "source": "THE CITY Interview",
          "date": "May 5, 2021"
        }
      ]
    },
    "wealthy": {
      "no-wealth": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "source": "New York Daily News",
          "date": "April 6, 2021",
          "url": "https://www.nydailynews.com/news/politics/new-york-elections-government/ny-nyc-mayoral-race-andrew-yang-taxes-20210225-yaxw24lervcxxms2afh6qrhb7m-story.html"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "“I would do it by cutting taxes not increasing taxes. I would do it by welcoming back the rich making sure that they are part of the fabric of New York. I would make sure that we engage the rich.”",
          "source": "WABC Republican Primary Debate",
          "date": "April 1, 2021",
          "url": "https://youtu.be/9pnNmm7iakQ?t=1297"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"If we have enough to cover those costs then we shouldn't be taxing people more. If we haven't gotten enough money to cover the costs for the things we need to do, then everyone needs to pay a little more,\"",
          "source": "NY1 News",
          "date": "April 6, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/07/mayoral-candidates-react-to-increased-taxes-for-wealthy-new-yorkers"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"I disagree with the new state law that increases taxes on the wealthy. The wealthy will simply move to Florida, or Texas or some other states.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "McGuire said he believes wealthy people like him should pay more, but not if federal stimulus funding is set to come in. ",
          "source": "NY1 News",
          "date": "April 6, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/07/mayoral-candidates-react-to-increased-taxes-for-wealthy-new-yorkers"
        }
      ],
      "five-million": [
        {
          "slug": "dianne-morales",
          "quote": "\"People want to be in New York. The idea that the wealthy will leave because we’ve raised their taxes is a fear mongering tactic that has served those in power too long. What this WILL do is raise real revenue to lift up struggling New Yorkers. #TaxTheRich.\"",
          "source": "Twitter",
          "date": "April 7, 2021",
          "url": "https://twitter.com/Dianne4NYC/status/1379791806796271620"
        },
        {
          "slug": "eric-adams",
          "quote": "\"If you make more than $5 million a year, we are asking you to pay a little more to stabilize our city.\"",
          "source": "NY1 News",
          "date": "April 6, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/07/mayoral-candidates-react-to-increased-taxes-for-wealthy-new-yorkers"
        },
        {
          "slug": "maya-wiley",
          "quote": "“The one thing I consistently hear is that Maya, if you share with us a plan for what our money will do, and we know that improves our schools, that it's going to help with public transit, we're willing to pay more, but we want to see managerial leadership.”",
          "source": "Citizens Budget Commission Mayoral Candidate Forum",
          "date": "Feb. 24, 2021",
          "url": "https://cbcny.org/newsroom/managing-nycs-fiscal-crisis"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan proposes working with the adminstration and Congress to ensure that the wealthy pay their fair share of the tax burden, including by rolling back Trump tax cuts on the wealthy.",
          "source": "The Plan for the City of New York",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        },
        {
          "slug": "art-chang",
          "quote": "Chang contends the wealthy wish to contribute under the right circumstances: \"If I present the question in the following way, I get 100% agreement: 'If you trust how your money is being spent, are you willing to pay more in taxes?' And the answer is yes.\" ",
          "source": "THE CITY Interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "ten-million": [
        {
          "slug": "paperboy-prince",
          "quote": "\"There are more ways to tax the ultra wealthy, but we have to do it in a futuristic way.\"",
          "source": "THE CITY Interview",
          "date": "May 5, 2021"
        }
      ]
    },
    "stock": {
      "no-stock-tax": [
        {
          "slug": "andrew-yang",
          "quote": "“There are other ways that we can generate revenue in ways that are constructive to New Yorkers, like taxing vacant lots at fair market value, which generate hundreds of millions. So there are different approaches.”",
          "source": "THE CITY interview",
          "date": "May 8, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia opposes taxing stock transfers because the stock market \"already could be anywhere\" and she says the move will drive the financial industry to relocate. ",
          "source": "THE CITY interview",
          "date": "April 13, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"This would make New York the only state to impose such a tax, which would be easily avoidable by moving stock transaction processing to other locations, such as New Jersey, which is already ideally positioned to support this type of operation.\"",
          "source": "Statement to THE CITY",
          "date": "April 29, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We need New York City to be a mecca of banking, commerce, tourism. If you start adding new taxes, then people will take their business elsewhere.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"Taxes on stock transfers just seems to penalize folks for investing.\"",
          "source": "THE CITY Interview",
          "date": "May 5, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "stock-tax": [
        {
          "slug": "dianne-morales",
          "quote": "“I am wholeheartedly in support of the Invest in our New York Act, which will tax the rich and bring resources back to the city that are sorely needed.” This package of bills includes a financial stock transfer tax.",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://www.facebook.com/247597859209904/videos/143604754284238"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley supports the stock transfer tax to fund her plan to ban evictions.",
          "source": "Campaign website",
          "date": "",
          "url": "https://mayawileyformayor.com/plan-to-end-evictions-keep-new-yorkers-in-their-homes-and-fight-homelessness/"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We’re going to have to identify revenue streams — steady, stable revenue streams — to transform our amazing city.... That’s why I support the Invest in Our New York City agenda in Albany.” This package of bills includes a stock transfer tax.",
          "source": "Daily News",
          "date": "Feb. 23, 2021",
          "url": "https://www.nydailynews.com/news/politics/new-york-elections-government/ny-nyc-mayoral-race-scott-stringer-wealth-tax-albany-20210223-dou7vkpts5gglgukstbrwdtppy-story.html"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "borough": {
    "staten-island": {
      "restore-now": [
        {
          "slug": "andrew-yang",
          "quote": "The ferry is “one of the main ways people get from Staten Island to the rest of the city and if you have hours of the day, even very late at night, when you don't have service, then it's going to mean that some people might not otherwise be spending time out and about are going to have their ability to get home limited”",
          "source": "THE CITY interview",
          "date": "May 8, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We have to make it so that public transit is available across the city and that is the lifeline for Staten Island. And we know that many essential workers need the ability to take the ferry, otherwise, we are incentivizing parties.”",
          "source": "THE CITY interview",
          "date": "May 16, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "A spokesperson for Wiley said she would restore Staten Island Ferry service every half hour 24/7 so that \"essential workers and overnight workers in Staten Island can continue to have transportation.\"",
          "source": "Statement to THE CITY",
          "date": "May 17, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“The Staten Island ferry is an absolutely essential lifeline for residents of Staten Island to be able to commute. And with the city really this fall reopening … it's going to be absolutely critical that we have that service in place as quickly as possible.”",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "date": ""
        }
      ],
      "restore-soon": [
        {
          "slug": "curtis-sliwa",
          "quote": "“The reason you need it [the Staten Island Ferry] is the city is starting to open up now 24 hours soon. The subways today are open 24 hours. So why would we not open up service on the Staten Island Ferry 24 hours.?”",
          "source": "THE CITY interview ",
          "date": "May 17, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"I always view the Staten Island Ferry as a transfer...most of the people who take the Staten Island Ferry are taking the bus on one end and or the subway on the other end.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“During my first term, we want to do an analysis to look at ridership. We want to have all of the data.... On the peak hours, the non peak hours, how many people do we have actually utilizing the service and then resume the service accordingly so that people have access.”",
          "source": "THE CITY Interview",
          "date": "May 12, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "manhattan": {
      "study-model": [
        {
          "slug": "andrew-yang",
          "quote": "\"When you say rent control, to me, you'd want to try and ensure that small businesses can survive, particularly the types of mom and pops that define New York,  but I wouldn't want to have like, you know, hard and fast rules that may work in some part of the city and not others.\"",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2020",
          "url": "https://www.facebook.com/tenantinquilino/videos/143604754284238"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“Let's see if market forces lower the prices and that new people get involved in opening up businesses. Meantime, we can study commercial rent control, rent stabilization. See if it even makes sense.”",
          "source": "THE CITY interview ",
          "date": "May 17, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We need to look at that more closely because it is literally like, you know, does that mean that that person, who's maybe not even really doing business anymore or something that's no longer even paying, is trying to make money in their business but just as a really cheap rent stays in place.”",
          "source": "THE CITY interview",
          "date": "April 13, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "Chang cited a model in Kyoto, Japan, where business of certain trades are gauranteed a space. \"There are certain certain things that I would love to see preserved in New York, but I'm not really sure what that would look like.\"",
          "source": "THE CITY interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"I'm not sure if it would work, we do need to figure out a way to to ensure that small businesses are able to thrive in New York City. My biggest concern is the influx of chain stores.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ],
      "yes-comm-rent-control": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "A spokesperson for Wiley said she would work toward implementing a system that helps small business owners to pay their rent. Her plan is called Save Our Small Business and it includes protecting commercial tenants, reducing commercial vacancies and committing to create a citywide model for commercial rent stabilization.",
          "source": "Statement to THE CITY",
          "date": "May 17, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"The rent is too damn high.... We can't continue to commodify necessities.\" ",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“If we want to talk about having small businesses come back and be successful, we need to make sure that we give them the resource to achieve that. And I think the rents for commercials have really gotten out of control.”",
          "source": "THE CITY Interview",
          "date": "May 12, 2021"
        }
      ],
      "no-comm-rent-control": [
        {
          "slug": "eric-adams",
          "quote": "Asked if he would support rent control for commercial tenants, Adams said no.",
          "source": "NYC Mayoral Candidate Forum on Tenants Rights",
          "date": "Feb. 27, 2021",
          "url": "https://www.facebook.com/tenantinquilino/videos/143604754284238"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“The problem is that commercial rent control is a very blunt tool. It would protect large chain stores that can afford the rent…. I would say is that they can see of our storefronts is one of the most important problems we have right now and, you know, the business owners, as well as property owners, are really struggling to fill those spaces.… It's possible that commercial rent control, it certainly isn't going to help fill those vacancies.”",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "brooklyn": {
      "no-pipeline": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "A spokesperson for Adams said he “will stop projects like the North Brooklyn pipeline that threaten[s] to move us backwards toward greater reliance on fossil fuels”.",
          "source": "BK Reader",
          "date": "March 26, 2021",
          "url": "https://www.bkreader.com/2021/03/26/nyc-mayor-race-brooklyn-borough-president-climate-policy-north-brooklyn-pipeline-yang-adams-wiley-stringer/"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“You have to begin taking steps to move from a fossil fuel economy to renewable energy and that is my focus. So let's invest in our renewable energy and bringing more renewable down from upstate New York, where they are doing solar farms and hydro.\"",
          "source": "THE CITY interview",
          "date": "May 16, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley's website says she would \"prohibit new fossil fuel infrastructure and funding sources, including pipelines and gas turbines, and support ongoing grassroots fights against fossil fuel infrastructure like the No North Brooklyn Pipeline organizing effort.\"",
          "source": "Campaign website",
          "date": "",
          "url": "https://mayawileyformayor.com/maya-wileys-community-first-climate-action-plan/"
        },
        {
          "slug": "scott-stringer",
          "quote": "“With fracked gas already flowing through segments of the North Brooklyn Pipeline, it is past time to start acting on climate solutions to end the era of fossil fuel growth in New York.”",
          "source": "BK Reader",
          "date": "March 26, 2020",
          "url": "https://www.bkreader.com/2021/03/26/nyc-mayor-race-brooklyn-borough-president-climate-policy-north-brooklyn-pipeline-yang-adams-wiley-stringer/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“This project is in direct opposition to my goals to reach net zero emissions by 2050. And in addition, I've heard real concerns from residents about the project, the root of the project, the disruption that it would cause and I'm deeply concerned about that.”",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"The city should be 100% focused on reducing our carbon emissions footprint, not giving room to expand carbon emissions, which would this would clearly do.\"",
          "source": "THE CITY interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"Pipeline would negatively affect the marginalized communities and families that live there and cost a lot of money in the process.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        }
      ],
      "review-route": [
        {
          "slug": "curtis-sliwa",
          "quote": "“I would be open to look at the route, but I'm not afraid of natural gas. If we had to look at all the pipes that are on the ground, the transport different of our needs, we will never have anything other than water.\"",
          "source": "THE CITY interview ",
          "date": "May 17, 2021"
        }
      ],
      "yes-pipeline": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We have a substantial natural gas infrastructure that's in place. And we do need a reliable pipeline to serve all of the natural gas customers.\" ",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        }
      ]
    },
    "bronx": {
      "new-stadium": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "if-free": [
        {
          "slug": "curtis-sliwa",
          "quote": "“We shouldn't be subsidizing any arenas, any stadiums, any facilities that have professional sports where they're making money. So absolutely, if they had the money, not a penny of tax dollars should go to that”",
          "source": "THE CITY interview ",
          "date": "May 17, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“These are organizations that are wealthy organizations. We should be using public money for breaking back our economy and helping people with health care, in schools.\"",
          "source": "THE CITY interview",
          "date": "May 16, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I think there is a great model. Mayor [David] Dinkins built Arthur Ashe stadium [at Flushing Meadows in Queens] as a national model. There was no public subsidy, but there was also an ongoing return to New Yorkers from the earnings.... I think we can do it just as we did with Arthur Ashe Stadium.”",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"I'm generally against public subsidies or tax breaks for private investments.\"",
          "source": "THE CITY interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"There should be zero subsidies for sports stadia. The wealthy owners of the sports stadiums should foot the bill themselves.\"",
          "source": "THE CITY Interview",
          "date": "April 29, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"I would love for New York City to have the first arena centered around a women's sports franchise.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“If we're saying that the city is in a crisis, then when you're in crisis mode, you can't go out give out subsidies. You just can't do it.”",
          "source": "THE CITY Interview",
          "date": "May 12, 2021"
        }
      ],
      "no-stadium": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        }
      ]
    },
    "queens": {
      "no-yard": [
        {
          "slug": "curtis-sliwa",
          "quote": "“We first fill up all these empty -- I'll call them catacombs -- these empty buildings of glass, steel and concrete before we start trying to develop other areas”",
          "source": "THE CITY interview ",
          "date": "May 17, 2021"
        }
      ],
      "review-yard": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "A spokesperson for Wiley said she will review the critical components of the Sunnyside Master Plan because “the City has invested billions of dollars in affordable housing development over the past seven years” and the city is still facing a housing crisis.",
          "source": "Statement to THE CITY",
          "date": "May 17, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“We need to look at a few things. One is to go back and make sure there was a field full process for community input....The other issue is that we have to reevaluate it in the light of the COVID recovery…and particularly, what resources are we able to access from the federal government.... I think it's possible to build, to create the plan more quickly.”",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"The plan is just such a beautiful dream. But it is a dream.\"",
          "source": "THE CITY interview",
          "date": "April 30, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "\"It's about listening to the folks that are most affected. And what happens is with plans like this, the people that are most affected don't find out until it's already set in stone.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“I think that it's important that we proceed with the plan, but I also think we need to take a step back and look at it and see if it still makes sense. And we also need to reaffirm the community's input as it relates to this plan.”",
          "source": "THE CITY Interview",
          "date": "May 12, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "yes-yard": [
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia said developing Sunnyside Yard is an opportunity to “engage with the community” but supports the plan as is because she doesn’t “want to slow things down.”",
          "source": "THE CITY interview",
          "date": "April 13, 2021"
        }
      ]
    }
  },
  "leadership": {
    "nonprofit": {
      "add-disclosure": [
        {
          "slug": "paperboy-prince",
          "quote": "\"I wouldn't want to stop a good thing as far as someone who's actually trying to help the community. But I think there should be a cap on the amount of funds raised.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"As mayor I will eliminate all forms of quid pro quo and pay to play, including elected officials benefiting from the use of non-profits.\"",
          "source": "Twitter ",
          "date": "May 18, 2021",
          "url": "https://twitter.com/RayForMayor/status/1394760130596675586"
        }
      ],
      "no-soliciting": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"This is a type of problem Mayor de Blasio and Eric Adams have run into,\" Foldenauer said — \"an opportunity for people with interests before the city to seek improper influence.\" ",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"I point right to the Eric Adams situation with One Brooklyn.... It's an end run around the intent of contribution limits in New York City politics.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“When you are an elected official, and everybody knows, the reason people are giving to your nonprofit is they want something in return. Everyone understands that. It is the most corrupt practice that exists in New York City and must be stopped.”",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "\"We can't even allow the perception that government decisions could be driven by private donations. And that's why, as mayor. I'll ensure that no one would business before the city will be able to donate to an elected official, period.\"",
          "source": "Twitter",
          "date": "May 18, 2021",
          "url": "https://twitter.com/scottmstringer/status/1394679345864605703"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "Taylor said allowing non-profit organizations to donate to political campaigns creates \"an unequal playing field, favoring current officials and does not allow grassroots candidates the opportunity to compete.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        }
      ],
      "as-permitted": [
        {
          "slug": "eric-adams",
          "quote": "“I did not go from being a person that enforced the law to become one that breaks the law,” Adams said when questioned about fundraising for his Brooklyn borough president's office nonprofit One Brooklyn.",
          "source": "The New York Times",
          "date": "May 16, 2021",
          "url": "https://www.nytimes.com/2021/05/16/nyregion/eric-adams-fund-raising.html"
        }
      ]
    },
    "veto": {
      "veto-rarely": [
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "\"The mayor would be would have to be deeply collaborative with City Council, but I could envision a time when the City Council is for whaterever reason is intent on pushing through a bill that I disagree with.\" ",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        }
      ],
      "veto-often": [
        {
          "slug": "aaron-foldenauer",
          "quote": "Foldenauer said vetoing a bill \"sends a message to the City Council that the council members need to work with the mayor before finalizing language in a bill in the first place.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“Well, especially if the DSA ends up controlling the City Council, I am going to have to veto a lot a lot of their legislation, because they want to defund the police even more. They don't want tenants — whether commercial or residential — to pay rent. They don't want gas pipelines in certain areas.... So I'll be at war with the DSA candidates and my only chance to balance is with the veto power.”",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "hiring": {
      "any-position": [
        {
          "slug": "paperboy-prince",
          "quote": "Paperboy Prince said people worked on their campaign  would \"still go through a process where they're vetted under the same scrutiny\" as other candidates.",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "Chang said some of his contributors are of \"extraordinary talent\" and that he \"would not want to foreclose the opportunity of being able to hire some of those folks.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I want to be very clear that every appointee in the Donovan administration would have to meet strict qualifications for the role. And so, I want to be very clear that making a contribution should have absolutely nothing to do with the appointment, but I don't think it should disqualify someone from that.”",
          "source": "THE CITY interview",
          "date": "May 16, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"We need to look at the dollar values of the donation.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        }
      ],
      "only-advisory": [
        {
          "slug": "curtis-sliwa",
          "quote": "“In New York City, which has a lot of Democrats, a lot of liberals, a lot of progressive, I am probably going to have to appoint quite a few [campaign contributors] because they are skilled, they are knowledgeable, they are doers…but they cannot be in the leadership position. Advisory, you know, part of a board where there are other members, yes, but they cannot be the head of any of these agencies.”",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        }
      ],
      "no-posting": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        }
      ]
    },
    "style": {
      "partner": [
        {
          "slug": "paperboy-prince",
          "quote": "\"We need to have love leaders,\" who focus on \"bringing people together,\" and \"collobaration and not competition.\" ",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "Chang cited his time at NYC Votes, an election education campaign, as an example of partnering private firms with the city Campaign Finance Board. ",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "\"My management style is that I’m really good at surrounding myself with people who I think are smarter than me, people who I know sort of offset the different things that I may or may not bring to the table. Very collaborative in terms of trying to solicit people’s ideas and thoughts and also being able to co-create those solutions and strategies.\"",
          "source": "The New York Times",
          "date": "May 10, 2021",
          "url": "https://www.nytimes.com/2021/05/10/opinion/dianne-morales-endorsement-interview.html"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"You have to partner with City Council to get the legislation done. But you also have to have the right people to be able to implement it so that you can get the right result.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        }
      ],
      "decider": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"When COVID first hit, have we acted promptly, we could have prevented innumerable deaths and sicknesses that resulted. So one has to be able to make quick decisions and that's what I'm prepared to do.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "\"I believe I have the Bloomberg style with an asterisk — put the right people in place and then use his favorite quote: Don’t f+++ it up. But I also believe, and I live by this, you have to inspect what you expect or it’s all suspect. When I see a pilot in the cockpit of a plane, he has in front of him a bunch of instruments and dials to let him know about wind speed, takeoff, view, everything. If he flies that plane without those instruments, I don’t care how competent he is, he is liable to crash.\"",
          "source": "Bloomberg Opinion",
          "date": "Feb. 22, 2021",
          "url": "https://www.bloomberg.com/opinion/articles/2021-02-22/new-york-mayor-s-race-eric-adams-puts-priority-on-city-s-safety?sref=sxorlmMs"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"My management style is one where I’ve managed large businesses that are similar to NYCHA.... I managed them from the depths of crisis. We’re going to find the best talent. You’ve got to attract. You’ve got to recruit and retain the best. Empower them and give them metrics.\"",
          "source": "The New York Times",
          "date": "May 10, 2021",
          "url": "https://www.nytimes.com/2021/05/10/opinion/ray-mcguire-endorsement-interview.html"
        }
      ],
      "delegator": [
        {
          "slug": "andrew-yang",
          "quote": "“I’m someone who wants to identify people who are passionate and dedicated and mission-driven, and then wants to give them room to run.... You need to empower leaders and managers and in different environments and different agencies so that they feel like, as long as their values are sound and their process is good, that they can make decisions on their own.”",
          "source": "The New York Times",
          "date": "May 10, 2021",
          "url": "https://www.nytimes.com/2021/05/10/opinion/andrew-yang-endorsement-interview.html"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "\"You have to be a delegator because our leaders are always acting pretentious, omnipotent, like they know everything.... I'm not an expert. So if I appoint an expert to be in charge of an agency, why wouldn't I allow the expert, he or she, to do the job?\"",
          "source": "THE CITY interview",
          "date": "May 17, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"At a moment where there are so many things to fix in New York City, where we need to get so many things done at once at once, it's the only way we're really going to improve that repair and rebuild the city quickly. And is very different from the way we see Mayor de Blasio lead these last eight years, when he's been unwilling to listen to his commissioners and to allow them to go get big things done.”",
          "source": "THE CITY interview",
          "date": "May 16, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“The mayor [de Blasio] is not a manager. The mayor has been a public advocate, and that is where he got his training. I fundamentally manage differently. It is about bringing the smartest people together, listening to them, developing the plan and holding people accountable for delivery.”",
          "source": "The New York Times",
          "date": "May 10, 2021",
          "url": "https://www.nytimes.com/2021/05/10/opinion/kathryn-garcia-endorsement-interview.html"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Part of my ability to do a good job has not that much to do with me but with my ability to attract the best and the brightest into government and to give them a mission and direction.\"",
          "source": "Bloomberg",
          "date": "March 30, 2021",
          "url": "https://www.bloomberg.com/opinion/articles/2021-03-30/nyc-mayoral-race-candidate-scott-stringer-on-value-of-experience?srnd=opinion&sref=X9N3NABa"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"This is how I managed inside City Hall and got things done — like getting every single apartment in Queensbridge Houses free broadband…by recognizing it's a team effort and that you have to have the smartest and most qualified folks in all our important positions. You have to listen to them.\"",
          "source": "Bloomberg Opinion",
          "date": "April 5, 2021",
          "url": "https://www.bloomberg.com/opinion/articles/2021-04-05/nyc-mayoral-race-candidate-maya-wiley-on-restoring-government-trust?srnd=opinion&sref=X9N3NABa"
        }
      ]
    }
  },
  "homelessness": {
    "nypd-response": {
      "yes-nypd-response": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“I've been consistent in saying that we need a police service, not a police force, so we do need to improve the training that officers are given so that they're prepared to adequately deal with people who have mental illnesses. EMTs and mental health experts can accompany police officers when they're working with homeless individuals to make sure that people get the help that they need.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "“There may be occasions when a police officer would be present but they should not be the primary actor. They should be standing a ways away as a tertiary or or support staff while someone else who's better trained to actually intervene with a person who's having an issue is leading and making sure that the issue is being addressed the right way as opposed to having someone who's not trained for that kind of that kind of activity.”",
          "source": "Caring & Compassionate New Deal for NYC forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=5153"
        },
        {
          "slug": "eric-adams",
          "quote": "Adams's campaign proposes refunding the Transit Homeless Outreach Unit, a partnership between the NYPD and the city social service agency. The proposal also includes “more active oversight of units that could have a more significant presence, such as the midnight train unit that is meant to focus on sleeping and intoxicated passengers.”",
          "source": "The Subway Safety Plan",
          "date": "May 18, 2021",
          "url": "https://ericadams2021.com/wp-content/uploads/2021/05/Subway-Safety-Plan.pdf"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“The NYPD had a Homeless Outreach Unit that was closed when De Blasio took a billion dollars out of their budget but the city has not replaced what the police used to do.... They have to restore the homeless outreach unit from the police because nobody is doing it now.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "no-nypd-response": [
        {
          "slug": "art-chang",
          "quote": "“We need to have trained mental health workers out there helping to convince these mentally ill homeless folks to get into supportive housing and off the street. And a police officer is also likely to aggravate situations and not help.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "“I've called for the creation of a community first responders department that would be staffed by people who are trained and skilled at intervention and the escalation in these situations: mental health, homelessness, and substance abuse”",
          "source": "First Democratic mayoral debate",
          "date": "March 2, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“The role of policing is supposed to keep people safe. Being homeless is not a crime, it's a condition that we created. So the response to a condition that we created should not be to bring in the police.”",
          "source": "THE CITY interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "“The reality is a big part of our safety problem in the subways is a mental health and homelessness problem, where we have the tools and resources to ensure that we have the proper outreach workers helping get folks who are mentally ill, or and or substance addicted out of the subways and into housing.”",
          "source": "First Democratic mayoral debate",
          "date": "March 2, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "paperboy-prince",
          "quote": "“There's a lot of police officers that are very good at dealing with folks that are in distress and that are dealing with mental health issues, but the fact is that they're just not trained to do that. And a lot of times, it ends with the wrong person going to jail, it ends with someone ending up hurt.”",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "“I know that we need a totally different way to respond in this city and so my plan calls for an alternative to 911 but it goes well beyond that as well. It is really investing in the teams that we need to respond but also creating real infrastructure for mental health care around this city.”",
          "source": "Caring & Compassionate New Deal for NYC forum",
          "date": "March 17, 2021",
          "url": "https://youtu.be/X9quYLIpeJw?t=3011"
        }
      ],
      "specifically": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"We do need to respond when the MTA says we need more cops in the subway, that does not mean we're not sending mental health professionals into the subway as well, so that we can get people the services they need and into supportive housing to deal with their mental health issues, as well as with their substance abuse issues. We can do both\"",
          "source": "First Democratic mayoral debate",
          "date": "March 2, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "scott-stringer",
          "quote": "“We've been cycling mental health issues in and out of the underground subways for decades. And the truth is, every time there's a call for more police, we end up not solving the problem. This is got to be the new way of looking at it. And that means investing in mental health professionals to make sure that people get supportive housing.”",
          "source": "First Democratic mayoral debate",
          "date": "March 2, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ]
    },
    "hotel": {
      "end-hotel": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“The homeless hotels must close and we shouldn't be placing particularly single homeless men in residential areas.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"Shift from a shelter strategy to a housing strategy also means instead of paying to rent hotel rooms we purchase suitable empty commercial spaces and convert them into 10,000 permanent supportive housing units.\"",
          "source": "Gotham Gazette",
          "date": "March 2, 2021",
          "url": "https://www.gothamgazette.com/opinion/10212-how-new-york-city-turn-tide-homelessness-housing-garcia"
        },
        {
          "slug": "scott-stringer",
          "quote": "“I want to take the vacant properties that the city owns, I want to give them not to revenue developers, but back to community based organizations with a subsidy that would be directed to reward low income housing and finally align the housing and homeless crisis because right now we are spending billions managing people in dangerous shelter conditions.”",
          "source": "Mayoral Candidates Meet Homeless New Yokers",
          "date": "Feb. 12, 2021",
          "url": "https://youtu.be/MjIs7YJ8Ubw?t=2821"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“Right now, if you go into Times Square, many of the hotels are COVID-19 homeless hotels. We'll never get tourists to come in, we don't have hotel rooms. So we have to return the homeless to the shelters.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "phase-out-hotel": [
        {
          "slug": "andrew-yang",
          "quote": "“The issue with the hotels right now is that they're being treated as a stopgap and we need to figure out what structures can actually be converted into housing ongoing and then have that be a more longstanding solution.”",
          "source": "Future of Family Homelessness and Poverty Forum",
          "date": "May 20, 2021",
          "url": "https://youtu.be/i1uBlL4CbJ4?t=3441"
        },
        {
          "slug": "art-chang",
          "quote": "“It's been used to solve an immediate problem but to continue to rely on this is, to me, a capitulation to this idea that we are going to have this continuing wave of homelessness.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“My goal is to look at a lot of the zombie homes that we have in New York and work to increase the number of firms that we utilize for construction to rehab those zombie homes to provide affordable housing for the homeless. I also want to look at commercial space because you have a lot more people that are working from home in this moment.”",
          "source": "THE CITY interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "paperboy-prince",
          "quote": "“We're going to make sure that there's housing for all the city. The best way to deal with the housing crisis is to give housing.”",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "yes-hotel": [
        {
          "slug": "dianne-morales",
          "quote": "\"We need to recognize housing is a human right and prioritize the provision of housing for everyone. That means really scouring our city for all the existing vacant spaces, particularly post-pandemic or mid-pandemic, including vacant hotel rooms, commercial spaces, office spaces, and really prioritizing making those spaces, converting those spaces into housing that can be provided for both the homeless people in the city and those that might be housing insecure.\"",
          "source": "The Brian Lehrer Show",
          "date": "April 28, 2021",
          "url": "https://www.wnyc.org/story/ask-mayor-tryouts-dianne-morales/"
        },
        {
          "slug": "maya-wiley",
          "quote": "“Instead of spending $3 billion a year on homeless shelters, we should be investing in folks having housing first, having supportive housing. We should be taking the 100 hotels that have been shuttered and turn them into affordable and permanently affordable housing for our folks who need it.”",
          "source": "Mayoral Candidates Meet Homeless New Yokers",
          "date": "Feb. 12, 2021",
          "url": "https://youtu.be/MjIs7YJ8Ubw?t=900"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan cites the Times Square Hotel, converted into a 652-unit permanent supportive housing development for formerly homeless adults. Donovan promote “single-occupancy units for permanent supportive housing.”",
          "source": "The Plan for the City of New York",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        }
      ]
    },
    "right-to-shelter": {
      "keep-right": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“One big problem we have is that there are a number of homeless people who are reluctant to go to shelters because they're afraid and have safety concerns with respect to those shelters. So the city needs to do a better job at keeping homeless shelters safe.… What we really need to do is help these homeless individuals get back on their feet and get them back into the workforce, so that they will no longer need shelter from the city.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"If I were mayor, we would end street homelessness in New York City and we would do it by reimagining the right to shelter as a right to housing.\"",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        }
      ],
      "renegotiate": [
        {
          "slug": "andrew-yang",
          "quote": "“We need more permanent affordable housing, the sheltering system is not meant to be permanent.”",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "art-chang",
          "quote": "“In situations like a pandemic, economic crisis and climate crisis, the effort should be to keep people in their homes. ... We know that for instance, housing a family in a temporary shelter costs $240 a night. That translates into about $53,000 a year....This is incredibly costly to the city, it is far more costly than just paying their rent.” ",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "“Anything that is available that is at our disposal, we should be converting to permanent affordable housing. We should not be perpetuating the shelter industrial complex.”",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“Everybody deserves the right to housing. Housing is a basic right. And it actually ends up costing us more when we don't provide people with the housing that they need and we focus on just temporary shelter.”",
          "source": "THE CITY interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“We have to fundamentally change our approach. Shelters are a Band-Aid for this solution to a long-term problem. We have to put housing first.... That is why my plan includes increasing the voucher amount to something you might actually be able to rent in the city of New York.”",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "maya-wiley",
          "quote": "“We need a housing-first strategy.”",
          "source": "First Democratic mayoral debate",
          "date": "March 2, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "paperboy-prince",
          "quote": "“There's a lot of housing that is already in certain neighborhoods that's old, that is deteriorating, that needs to be revamped and remodeled. I think we start there, but my goal is kind of to revolutionize the whole city and the architecture of the city.”",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Everyone talks about how to solve the homeless crisis. But no one talks about giving homeless people a home with supportive services. What I would do as mayor is have a housing plan that actually builds low income housing for the people who need it.\"",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/decision-2021/2021/05/14/first-democratic-debate-for-mayor"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"If I were mayor, we would end street homelessness in New York City. And we would do it by reimagining the right to shelter as a right to housing.\"",
          "source": "Mayoral Candidates Meet Homeless New Yokers",
          "date": "Feb. 12, 2021",
          "url": "https://youtu.be/MjIs7YJ8Ubw?t=2595"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“If you show up in New York City — you could be from Philadelphia, Newark, and claim that you are indigent, you have nowhere to stay — the city by federal court order has the responsibility to provide you with housing, food, medical care. We have to challenge that. People are taking advantage of this by coming in from surrounding cities that don't have a very good shelter system.… It's an overburden on our system.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ]
    },
    "30thstreet": {
      "keep-shelter": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“We need this facility on East 30th Street. We need as much space as we can for our homeless population. This is the main intake center for single adult males and we need the facility.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        }
      ],
      "close-shelter": [
        {
          "slug": "art-chang",
          "quote": "“The lack of safety there is one of the contributors to persistent chronic homelessness by people who do not want to enter the shelter system.... We have to think differently about this. So I think that we need to think about putting homeless intake centers or homeless crisis centers around the city.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "\"We have to expand the individual housing opportunities for the folks that are being warehoused in these shelters and also do a concerted effort to expand the number of affordable units that are available for families.\"",
          "source": "Curbed",
          "date": "April 22, 2021",
          "url": "https://www.curbed.com/2021/04/dianne-morales-housing-platform-nyc-mayor.html"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“People don't even feel safe going into these systems. So I want to eradicate homelessness and no longer allow homelessness to be big business.”",
          "source": "THE CITY interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        }
      ],
      "reserve-shelter": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        }
      ]
    }
  },
  "climate-change": {
    "flood-zones": {
      "build-seawalls": [
        {
          "slug": "paperboy-prince",
          "quote": "\"The same way how they want to build bigger buildings and higher buildings, I am going to build bigger forests, bigger jungles, more trees, more gardens, nature's farm and parks.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "\"As mayor, I will invest in the building of new flood protection projects along the city's waterfront, as well as supporting the rapid completion of existing efforts like the construction of dunes in the Far Rockaways.\"",
          "source": "Waterfront Alliance survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Andrew-Yang.WAsurvey.pdf"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales said she will develop natural and other protective measures such as sea walls or urban forestry through a \"a fully resourced and supported partnership with CUNY.\"",
          "source": "Waterfront Alliance Mayoral Candidates Survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Dianne-Morales.WAsurvey.pdf"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"We will expand bluebelt stormwater management strategies to other flood-prone parts of the City, including Southeast Queens, and restore wetlands to serve as a natural buffer to protect our waterfront communities.\"",
          "source": "Waterfront Alliance survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Kathryn-Garcia.WAsurvey.pdf"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"We have to be proactive. We have to invest in infrastructure.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "eric-adams",
          "quote": "\"I will utilize New York City’s capital budget to advance infrastructure that will strengthen our shoreline with hard and soft infrastructure.\"",
          "source": "Waterfront Alliance survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Eric-Adams.WAsurvey.pdf"
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"My major infrastructure plan is to accelerate resilient and sustainable infrastructure throughout New York City with a focus on Sandy-impacted neighborhoods like Coney Island, Hunts Point, Lower Manhattan, Red Hook, and the Rockaways.\"",
          "source": "Waterfront Alliance survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Ray-McGuire.WAsurvey.pdf"
        }
      ],
      "stop-building": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"One long-term solution to our climate crisis is for governments around the world to buy back the most vulnerable land along our coastlines.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "Chang said \"city will likely have to buy\" properties in flood-prone areas. ",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"I support flood buyouts and resettlement strategies for high-risk areas in addition to other adaptation and resilience efforts.\"",
          "source": "NY1",
          "date": "April 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/13/nyc-elections-2021-whos-running-nyc-mayor-candidates-on-environmental-plans"
        },
        {
          "slug": "scott-stringer",
          "quote": "Stringer called for expanding home buyout programs and replacing urban highways with parks. ",
          "source": "NY1",
          "date": "",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/13/nyc-elections-2021-whos-running-nyc-mayor-candidates-on-environmental-plans"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley called for \"transition of City-owned social infrastructure to become climate-ready, by investing in infrastructure to allow public schools, libraries, hospitals and Community Care Centers to act as climate-ready community hubs.\"",
          "source": "Waterfront Alliance survey",
          "date": "",
          "url": "https://waterfrontalliance.org/wp-content/uploads/2021/03/Maya-Wiley.WAsurvey.pdf"
        }
      ],
      "elevate-homes": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        }
      ]
    },
    "gas": {
      "phase-out-gas": [
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "\"I am 100% on board.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "\"We should be investing in clean, renewable energy sources and the infrastructure to support them now.\"",
          "source": "Twitter",
          "date": "Feb. 27, 2020",
          "url": "https://twitter.com/Dianne4NYC/status/1233091120772591619?s=20"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan says he wants to see \"all public and private buildings in New York City run on pollution-free electricity, phasing out the use of fossil fuels, including gas and oil, in all buildings.\"",
          "source": "Campaing website",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Ban all new fossil fuel infrastructure, including new pipelines or the redevelopment of power plants.\"",
          "source": "Campaing website",
          "date": "",
          "url": "https://stringerformayor.com/plans/climate-action/"
        },
        {
          "slug": "maya-wiley",
          "quote": "Wiley pledged to \"prohibit new fossil fuel infrastructure.\"",
          "source": "Campaing website",
          "date": "",
          "url": "https://www.mayawileyformayor.com/maya-wileys-community-first-climate-action-plan/"
        }
      ],
      "allow-hookup": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"If all of a sudden we were to tell developers that they can't have gas hookups, then the demand for units in those buildings may well go down, which would therefore decrease property values.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"I support an outright ban once we’ve established a faster pace at which we are moving towards renewable energy and that will be my priority.\"",
          "source": "NY1",
          "date": "April 13, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/13/nyc-elections-2021-whos-running-nyc-mayor-candidates-on-environmental-plans"
        }
      ],
      "ban-hookup": [
        {
          "slug": "eric-adams",
          "quote": "Asked whether NYC should ban all new fossil fuel infrastructure, Adams said \"Yes.\" ",
          "source": "NY1",
          "date": "April 21, 2021",
          "url": "https://www.ny1.com/nyc/all-boroughs/politics/2021/04/13/nyc-elections-2021-whos-running-nyc-mayor-candidates-on-environmental-plans"
        }
      ]
    },
    "energy-targets": {
      "finance-upgrades": [
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        },
        {
          "slug": "art-chang",
          "quote": "\"The city has to offer owners some financial models, some proofs of how this can work.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "Yang \"will use the City’s own buildings as demonstration projects for how landlords and building owners can meet the emissions reductions requirements and will advocate for state and federal tax credits to offset costs.\"",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.yangforny.com/policies/addressing-climate-change-and-building-a-resilient-nyc"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"Not only am I going to accelerate implementation of Local Law 97, get the tools and resources like PACE to every building that needs it. But we’re also going to lead with our public buildings. We’re going to make sure that public housing is a model around the world for sustainable, green housing.\"",
          "source": "City & State NY",
          "date": "April 23, 2021",
          "url": "https://www.cityandstateny.com/articles/policy/energy-environment/mayoral-hopefuls-tout-their-green-thumbs.html"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "Garcia called for \"incentivizing electrification and carbon savings--not slapping building owners with fines.\"",
          "source": "Twitter",
          "date": "Dec. 29, 2020",
          "url": "https://twitter.com/KGforNYC/status/1344024858250850306"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"A lot of these landlords are not making millions of dollars off of these premises. For the smaller and midsize ones, we have to support them financially.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "eric-adams",
          "quote": "Adams pledged to \"provide tax credits for innovative waste management and energy-efficient design.\" ",
          "source": "Twitter",
          "date": "April 22, 2021",
          "url": "https://twitter.com/ericadamsfornyc/status/1385224664633520129?s=20"
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "revise-law": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"The problem with the law currently is that it's an unfunded government mandate. It's very difficult to be a property owner in the city as it is and to all of a sudden impose additional fines without providing significant support is a problem.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“The owners, so far in the lockdown, when it comes to rent many of them have received no rent for either commercial space or residential space.... So they're desperately going to need help with this.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "no-action": [
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        }
      ]
    },
    "organic-waste": {
      "optional-ow": [
        {
          "slug": "paperboy-prince",
          "quote": "\"It's good for the environment.\"",
          "source": "THE CITY Interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "\"You have to roll it out in certain parts where you have the resources.\"",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.thecity.nyc/2021/5/12/22433369/nyc-mayoral-debate-where-to-watch-thursday-night"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"It should remain optional. And then we need to start doing some effective communication and education around it.\"",
          "source": "THE CITY Interview",
          "date": "May 20, 2021"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"Let’s start composting for real. They’ve gutted the composting plan. We only have 1% composting in a city that it should be scaled up to lead the nation.\"",
          "source": "City & State NY",
          "date": "April 23, 2021",
          "url": "https://www.cityandstateny.com/articles/policy/energy-environment/mayoral-hopefuls-tout-their-green-thumbs.html"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "mandatory-ow": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We do need to make we compost our waste. It starts with education but it also should become mandatory.\" ",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"This is clearly an area where we have an opportunity to lower costs for the city.\"",
          "source": "THE CITY Interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "Asked whether she'd commit to making the organic waste program citywide, Morales answered yes. ",
          "source": "First Democratic mayoral debate",
          "date": "May 13, 2021",
          "url": "https://www.thecity.nyc/2021/5/12/22433369/nyc-mayoral-debate-where-to-watch-thursday-night"
        },
        {
          "slug": "shaun-donovan",
          "quote": "\"We’ve got to lead the country in recycling. And we’re going to do that by bringing back organics recycling and making sure it works everywhere.\"",
          "source": "City & State NY",
          "date": "April 23, 2021",
          "url": "https://www.cityandstateny.com/articles/policy/energy-environment/mayoral-hopefuls-tout-their-green-thumbs.html"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "\"We have to bring back the composting program and ensure that it is at everybody’s doorstep, as well as in every big building. It’s going to have to be mandatory.\"",
          "source": "City & State NY",
          "date": "April 23, 2021",
          "url": "https://www.cityandstateny.com/articles/policy/energy-environment/mayoral-hopefuls-tout-their-green-thumbs.html"
        },
        {
          "slug": "eric-adams",
          "quote": "\"My goal as mayor will be to ensure that every New Yorker participates in the organic waste renewal program.\"",
          "source": "City & State NY",
          "date": "April 23, 2021",
          "url": "https://www.cityandstateny.com/articles/policy/energy-environment/mayoral-hopefuls-tout-their-green-thumbs.html"
        },
        {
          "slug": "maya-wiley",
          "quote": "\"By reducing the amount of waste we generate, expanding composting programs, and decarbonizing our waste handling systems, we can improve our environment and our economy, resulting in a healthier place to live and work.\"",
          "source": "Campaing website",
          "date": "",
          "url": "https://www.mayawileyformayor.com/maya-wileys-community-first-climate-action-plan/"
        }
      ],
      "maintain-ow": [
        {
          "slug": "curtis-sliwa",
          "quote": "“You start with the educational process. Same way they started separating bottles and cans. Originally people say it's not going to work, you know, bottles, cans and paper. And now people are used to it. But in some neighborhoods, they don't do a very good job.... So you have to really raise the standards in all neighborhoods.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ]
    }
  },
  "building-nyc": {
    "elevator": {
      "no-private-elevator": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“We don't want to override our zoning laws and allow the developers to build things that they shouldn't otherwise be building, just because they install an extra elevator. That wouldn't make sense.",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "“The MTA needs to be funded to create true accessibility across the subway system, and so many of our solutions, you know, rely on the private sector to do these things. And these, to me, are just kind of one-shot, fragmented deals that let the MTA off the hook.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“We have to stop giving these developers incentives to build higher buildings that only seem to benefit them. The cost of the elevator is not so significant that we have to give a developer an incentive. No. We could afford, utilize the funds that we're about to get from Biden to build elevators in subways.”",
          "source": "THE CITY interview ",
          "date": "May 20, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "mta-maintenance": [
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "\"That's a fair trade.\"",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "commit-maintenance": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        }
      ]
    },
    "broadband": {
      "low-cost-internet": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“It would be cost-prohibitive to build an entirely new network, considering how expensive it is to dig up the streets and install brand new infrastructure. … If we work with companies who already have an established infrastructure, we'll achieve the goal of universal broadband access much faster than trying to start from scratch.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "Yang's campaign said he would work with the governor’s office to implement the recent mandate that “all internet providers need to include a low-cost broadband plan.”",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.yangforny.com/policies/broadband-access"
        },
        {
          "slug": "dianne-morales",
          "quote": "Morales' campaign said her administration would launch a “citywide fiber-optic network” to bring free municipal broadband to New York City.",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.dianne.nyc/public-investment"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“We do need low-cost internet but I think it's important that the city partner with companies that do this because we want to make sure that it's done correctly.”",
          "source": "THE CITY interview ",
          "date": "May 20, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“There are two real things that are blocking us. One is just the cost. People don’t have it. It's not an infrastructure problem; fiber is there. They can’t afford it. The second big piece is, you are allowed, as the first homeowner on a block, to block that entire block from getting fiber. That's a rule change the City of New York can make. The third piece is, we as the City of New York give franchises to those folks who run the fiber.”",
          "source": "NYC Mayoral Forum, presented by Tech:NYC and Warby Parker",
          "date": "April 9, 2021",
          "url": "https://youtu.be/e7GLszlsU70?t=1695"
        },
        {
          "slug": "scott-stringer",
          "quote": "\"The City should immediately convene all Internet Service Providers (ISPs) and carriers operating in the five boroughs to discuss all possible options to quickly provide affordable and reliable internet service to every student in the city who lacks a high-speed broadband connection in their home or shelter. As part of that effort, the City should be prepared to offer subsidized and redeemable ‘Internet Passports’ for low-income families that can be used to purchase broadband service.\"",
          "source": "NYC Comptroller website ",
          "date": "Nov. 2, 2020",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-calls-on-doe-to-provide-internet-passports-to-all-low-income-families-to-guarantee-equal-internet-access-for-all-students/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "Donovan´s campaign said his administration would “work with the state government to pass a Universal Broadband For All bill, which will enshrine grantmaking to increase competition as well as provide grants and incentives to internet service providers” that invest in communities with limited or no access to broadband.",
          "source": "Campaign website",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        },
        {
          "slug": "ray-mcguire",
          "quote": "“This has got to be fundamental to who we are; access to broadband is essential. We need to make sure that the right people are at the table. And given the relationships that have been developed over the past 25 to 30 years, I have that access to the key decision-makers and we can bring those decision-makers to the table, so that we can ensure that, at a reasonable period with all deliberate speed, we provide Internet access and tablets to all New Yorkers.”",
          "source": "NYC Mayoral Candidates Address the Digital Divide",
          "date": "April 29, 2021",
          "url": "https://vimeo.com/543338186"
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“I think that really has to be in the private sector. I think the government has too much responsibility, too many expenditures. That should be something that can be provided by the private sector.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "public-internet": [
        {
          "slug": "art-chang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "“We need to turn our wifi services into a utility company, just as gas and light are part of the utility companies. We need to do the same with our WiFi.”",
          "source": "Law and Leadership Series: 2021 NYC Mayoral Election Conversation With Eric Adams and Kathryn Garcia",
          "date": "April 15, 2021",
          "url": "https://youtu.be/eQyFE1-5Q24?t=1838"
        },
        {
          "slug": "maya-wiley",
          "quote": "“A big part of it is asset-mapping of the assets the city government controls that it can both leverage with the private sector, to help the private sector get more infrastructure and expand it, but also figure out how we utilize that to create the community benefits that ensure everything from free service where we need to be free, to low-cost service so that people can afford it, even if they have low incomes, but at a price point they can afford.”",
          "source": "NYC Mayoral Forum, presented by Tech:NYC and Warby Parker",
          "date": "April 9, 2021",
          "url": "https://youtu.be/e7GLszlsU70?t=4732"
        },
        {
          "slug": "paperboy-prince",
          "quote": "“A strong public option would force [internet providers] to be better. It would also allow us to create more job opportunities in the city and it would allow us to take our place as a leader in the digital world.”",
          "source": "THE CITY interview ",
          "date": "May 10, 2021"
        }
      ]
    },
    "sidewalk-shed": {
      "repair-asap": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“The sidewalk sheds oftentimes stay up for years, and there is often little, if any, discernible work being done, and it affects our quality of life. … Sidewalk sheds also present additional dangers.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "“There are nearly 300 miles of New York City streets covered with scaffolding, and under current law, building owners have zero incentive to make the necessary repairs to prevent debris from hitting pedestrians.”",
          "source": "Crain's New York Business",
          "date": "Feb. 10, 2021",
          "url": "https://www.crainsnewyork.com/real-estate/yang-draws-renewed-attention-proposed-sidewalk-shed-legislation"
        },
        {
          "slug": "art-chang",
          "quote": "“A property owner may get a permit for a building shed, but then getting the permit to do the building work is not necessarily fully aligned. In an ideal situation, if you have a small building ... you need to have a sidewalk shed, but there's no reason why that couldn't and shouldn't be finished within 90 days.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "paperboy-prince",
          "quote": "“I've had some scaffolding that I feel like it's been up all my life in New York. So that's something I would definitely get to the bottom…not saying that 90 days would be an extreme penalty after that, but definitely something that incentivizes folks to complete these projects as quickly as possible.”",
          "source": "THE CITY interview ",
          "date": "May 10, 2021"
        }
      ],
      "review-rules": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "“We need to review the current process. We need to think about what the end result is. We have to also think about how the city can support these owners if they need some assistance.... But to just continue to put up sidewalk shed, at the sidewalk shed, no, it's not working.”",
          "source": "THE CITY interview ",
          "date": "May 20, 2021"
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "\"We need a top to bottom review to streamline the public construction contracting process. I will identify and wholly remove nonsensical and complex requirements that raise the prices of the most simple procurements and lengthens construction. I will also work with private contractors to expedite projects by issuing permits efficiently and enforcing reasonable time frames.\"",
          "source": "Tribeca Citizen",
          "date": "May 24, 2021",
          "url": "https://tribecacitizen.com/2021/05/24/the-candidates-2021-ray-mcguire-for-mayor/"
        }
      ],
      "focus-current": [
        {
          "slug": "eric-adams",
          "quote": "“New legislation I'm introducing with @JustinBrannan will make building inspections more cost-effective, saving building owners and the City millions. It will help us take down sidewalk sheds that stay up for years. Most importantly, it will make us safer.”",
          "source": "Twitter",
          "date": "Dec. 22, 2019",
          "url": "https://twitter.com/search?q=(%22sidewalk%20sheds%22%20OR%20%22sidewalk%20OR%20shedding%22)%20(from%3Aericadamsfornyc%2C%20OR%20from%3ABKBoroHall)&src=typed_query"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        }
      ]
    },
    "landuse-review": {
      "require-review": [
        {
          "slug": "aaron-foldenauer",
          "quote": "“We need more community input with respect to what is being built on various sites. And we also need to ensure that any new buildings fit in with the surrounding neighborhood.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "Chang considers the Uniform Land Use Review Procedure an “archaic and broken system,” and he is calling for a city charter revision commission to rewrite it. “What we need to have is continuous conversation and review with the city, communities and any private interests that are involved in those projects.”",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "“I actually believe that we need to fundamentally overhaul the way we do the land use process and how these decisions are made. I believe in the zoning of areas that have been historically underutilized, let's say, on the affordable housing front. … I do think it's important to prioritize communities with the lens of citywide balance and equity.”",
          "source": "The Brian Lehrer show",
          "date": "May 19, 2021",
          "url": "https://www.wnyc.org/story/nycs-next-mayor-economy-equity-dianne-morales"
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "“We need to change the city’s approach to land use and rezonings in ways that are principled. That means land use and rezonings that create and maintain affordable housing.… All land use and housing plans should include a fair distribution of resources and development that takes into account community needs and corrects for historic disinvestment and displacement.”",
          "source": "National Organization for Women – New York City questionnaire",
          "date": "",
          "url": "https://nownyc.org/issues/women-front-center-maya-wiley-questionnaire/"
        },
        {
          "slug": "paperboy-prince",
          "quote": "",
          "date": ""
        }
      ],
      "lower-review": [
        {
          "slug": "andrew-yang",
          "quote": "“Our city is in crisis, and we need to move efficiently, quickly and with the will of the people. To that end, we need to also make long-term changes” to Uniform Land Use Review Procedure.",
          "source": "Andrew Yang's YouTube channel",
          "date": "",
          "url": "https://youtu.be/ykIyOfvKiTI?t=500"
        },
        {
          "slug": "eric-adams",
          "quote": "“We need to modify the ULURP process in two ways to ensure we are building supportive housing quickly and efficiently. First, we need to fast-track 100% affordable supportive housing projects, immediately moving them to the front of the review line.… Second, we need to set a time limit for agency review during the pre-certification process, ending the monthslong wait.”",
          "source": "Correct Crisis Intervention Today NYC questionnaire",
          "date": "",
          "url": "http://www.ccitnyc.org/wp-content/uploads/2020/12/Eric-Adams-_-2021-Mayoral-Candidate-Mental-Health-Written-Questionnaire.pdf"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "“It’s about accelerating approvals for new housing construction, and streamlining the ULURP and environmental review process, as well as permit applications and inspections at the Buildings Department. And there are several other sister agencies that are not well coordinated.\"",
          "source": "Commercial Observer",
          "date": "March 16, 2021",
          "url": "https://commercialobserver.com/2021/03/the-race-to-gracie-mansion-interview-with-nyc-mayoral-candidate-kathryn-garcia/"
        },
        {
          "slug": "shaun-donovan",
          "quote": "The Donovan campaign said his administration “will enact land use reforms to update outdated zoning regulations, encourage inexpensive housing development on an expansive and equitable basis, and expedite processes to increase affordability.”",
          "source": "The Plan for the City of New York",
          "date": "",
          "url": "https://shaunfornyc.com/wp-content/uploads/2021/03/The-Plan-for-the-City-of-New-York.pdf"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“If you wanted to develop property right now, one City Council person can stand in your way...and that person would make the decision. That's not in the best interest of the city. So that procedure has to stop when it comes to land use.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ],
      "maintain-review": [
        {
          "slug": "scott-stringer",
          "quote": "“We need to have a land use process that involves a discussion, and the land use process by which tenants can participate. It can't just be a government's way or the highway.”",
          "source": "Housing Conservation Coordinators candidate forum",
          "date": "Dec. 5, 2020",
          "url": "https://youtu.be/hktFVkL2kls?t=2260"
        }
      ]
    }
  },
  "quality-of-life": {
    "casino": {
      "no-casino": [
        {
          "slug": "paperboy-prince",
          "quote": "\"I would be open to casinos after we establish our love centers, which are a place where folks can meet new people where they can get inspired, make friends, get help for issues that they're going through.\"",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"There's a lot of boom and bust involved in the gaming industry and the city should not take the risk of being exposed to that.\" ",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"Gambling as an industry is designed to take money from people and very often from people who are least able to afford it.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        }
      ],
      "yes-outerboroughs": [
        {
          "slug": "andrew-yang",
          "quote": "“New York City should have its own casino on Governors Island. And who’s going to use that casino? A lot of tourists. It's going to generate tons of money...you can see that thing becoming a major draw, generating hundreds of millions of dollars a year.”",
          "source": "The Breakfast Club",
          "date": "Jan. 14, 2021",
          "url": "https://youtu.be/f11bMcQxlII?t=1811"
        }
      ],
      "yes-manhattan": [
        {
          "slug": "curtis-sliwa",
          "quote": "",
          "date": ""
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        }
      ]
    },
    "airbnb": {
      "some-operators": [
        {
          "slug": "paperboy-prince",
          "quote": "\"What I have proposed is that the city create its own version of Airbnb that could compete with some of these companies and replace them.\"",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"Single-family homes in the city where they have a guest apartment — I think there should be some lightweight regulation for those. But having an apartment, having an additional source of income is how we make homeownership more affordable for New Yorkers across the board.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "source": "THE CITY interview",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "source": "Campaign website",
          "date": "",
          "url": "https://www.dianne.nyc/housing"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "eric-adams",
          "quote": "\"What cannot be allowed, what I do not support, and what we have increasingly seen, are commercial operators who make an end-run around our laws, displacing actual tenants for their own profit by illegally warehousing dozens of housing units that could be available for long-term rental.\"",
          "source": "Crain's New York Business",
          "date": "June 19, 2018",
          "url": "https://www.crainsnewyork.com/article/20180619/POLITICS/180619886/airbnb-loses-ally-in-clash-with-city-council"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "\"So many men and women, especially now, after the pandemic, landlords have had no rent to pay for water, sewage, electricity. They haven't been able to evict anybody because of the moratorium. It has to earn income any way they can, we have to help them.”",
          "source": "",
          "date": "May 21, 2021",
          "url": "THE CITY interview"
        }
      ],
      "all-rentals": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"We have a housing crisis in the city and one driving factor of that crisis are all of the housing units that are being illegally used as hotels.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "“Airbnb has grown exponentially at the expense of New Yorkers who face rising rents and the risk of being pushed out of communities they helped build. If we’re going to preserve the character of our neighborhoods and expand our middle class, we have to put people before profits. It’s that simple.”",
          "source": "NYC Comptroller report",
          "date": "May 3, 2018",
          "url": "https://comptroller.nyc.gov/newsroom/comptroller-stringer-report-nyc-renters-paid-an-additional-616-million-in-2016-due-to-airbnb/"
        }
      ],
      "let-airbnb": [
        {
          "slug": "joycelyn-taylor",
          "quote": "\"There are a lot of homeowners that are struggling right now. I want to make sure that we give them the option to still be able to generate some revenue and maintain their homes and pay them off.\"",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        }
      ]
    },
    "restroom": {
      "city-maintain": [
        {
          "slug": "paperboy-prince",
          "quote": "\"There should be public restrooms on every block in New York City. There should be as many public restrooms as possible.\"",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "aaron-foldenauer",
          "quote": "\"One way to build more restroom facilities is to think about public-private partnerships where developers and others are encouraged or incentivized to make available and build public restroom facilities.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "source": "THE CITY interview",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"We should be able to provide that, not just in Manhattan, but throughout the boroughs in various areas. And we need to make sure that they're clean and they're safe, because as human beings, we have to use the restrooms.\"",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "\"The era of sending a search party to find a bathroom at a park or playgound will be over.\"",
          "source": "Twitter",
          "date": "May 19, 2021",
          "url": "https://twitter.com/TyroneCStevens/status/1395068227940757507"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“Public lavatories should be open with bathroom attendants, you know, who are servicing it. Again, Europe has that, they treat this citizen so much better when it comes to having bathrooms and public accommodations.”",
          "source": "",
          "date": "May 21, 2021",
          "url": "THE CITY interview"
        }
      ],
      "no-restroom": [
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        }
      ]
    },
    "street-vendor": {
      "expand-vendor": [
        {
          "slug": "paperboy-prince",
          "quote": "\"It should be done on a rolling basis. And there shouldn't necessarily be a cap. It should be a situation where we allow more folks to pursue their dreams.\"",
          "source": "THE CITY interview",
          "date": "May 10, 2021"
        },
        {
          "slug": "art-chang",
          "quote": "\"Licensing actually provides a way to manage the geographic distribution of the street vendors. More importantly, it allows street vendors to be able to have a claim to legitimacy for their businesses.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "andrew-yang",
          "quote": "",
          "date": ""
        },
        {
          "slug": "dianne-morales",
          "quote": "\"Street vendors are part of the fabric of our city. We should empower and protect them.\" ",
          "source": "Twitter",
          "date": "April 11, 2021",
          "url": "https://twitter.com/Dianne4NYC/status/1381302255601745924?s=20"
        },
        {
          "slug": "maya-wiley",
          "quote": "",
          "date": ""
        },
        {
          "slug": "scott-stringer",
          "quote": "",
          "date": ""
        }
      ],
      "evaluate-vendor": [
        {
          "slug": "aaron-foldenauer",
          "quote": "\"People in New York City enjoy street vendors. But we also have to balance the needs of street vendors with brick and mortar retailers who have also been struggling.\"",
          "source": "THE CITY interview",
          "date": "May 19, 2021"
        },
        {
          "slug": "fernando-mateo",
          "quote": "",
          "date": ""
        },
        {
          "slug": "shaun-donovan",
          "quote": "",
          "date": ""
        },
        {
          "slug": "kathryn-garcia",
          "quote": "",
          "date": ""
        },
        {
          "slug": "joycelyn-taylor",
          "quote": "\"We want these vendors to be able to get their licenses, we want them to be successful. We want to cut down on bureaucracy. If we're not able to do that and we just increase the numbers, it'd have been a waste of time.\"",
          "source": "THE CITY interview",
          "date": "May 21, 2021"
        },
        {
          "slug": "ray-mcguire",
          "quote": "",
          "date": ""
        },
        {
          "slug": "curtis-sliwa",
          "quote": "“It is unfair that you would have so many vendors in the street who could charge much lower rates, but not have to pay taxes, not have to have insurance, not have to pay minimum wage to employees as a normal store would have to do. So you have to really wait until things return back to normal.”",
          "source": "",
          "date": "May 28, 2021",
          "url": "THE CITY interview"
        }
      ]
    }
  }
}